// ============================================================================
// ROUTES EDITOR + VISUAL BUILDER
//
// Extracted from index.html for editability \(was monolithic ~8000 lines\).
// Loaded as <script type="text/babel" src="./builder.js"> in index.html.
// Defines: parseYamlToRouteDef, generateCamelYaml, generateStepYaml,
// emitGenericStep, emitYamlValue, formatScalar, getNodeColor, yamlExpr,
// loadCatalog, StepSelectorModal, RouteBuilderCanvas, NewRouteBuilderModal.
// ============================================================================

// Re-destructure React hooks at file scope so each script tag is self-contained.
// `var`, not `const`: every text/babel script shares one global scope, so a second
// `const` binding of these names is a redeclaration SyntaxError now that Babel compiles
// JSX only (data-presets="react") instead of downlevelling to ES5.
var {useState,useEffect,useCallback,useRef,useMemo}=React;
function SaveActionIcon({size=18}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" fillRule="evenodd" d="M20.536 20.536C22 19.07 22 16.714 22 12c0-.341 0-.512-.015-.686a4.04 4.04 0 0 0-.921-2.224a8 8 0 0 0-.483-.504l-5.167-5.167a9 9 0 0 0-.504-.483a4.04 4.04 0 0 0-2.224-.92C12.512 2 12.342 2 12 2C7.286 2 4.929 2 3.464 3.464C2 4.93 2 7.286 2 12s0 7.071 1.464 8.535c.685.685 1.563 1.05 2.786 1.243v-.83c0-.899 0-1.648.08-2.242c.084-.628.27-1.195.725-1.65c.456-.456 1.023-.642 1.65-.726c.595-.08 1.345-.08 2.243-.08h2.104c.899 0 1.648 0 2.242.08c.628.084 1.195.27 1.65.726c.456.455.642 1.022.726 1.65c.08.594.08 1.343.08 2.242v.83c1.223-.194 2.102-.558 2.785-1.242M6.25 8A.75.75 0 0 1 7 7.25h6a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8" clipRule="evenodd"></path>
      <path fill="currentColor" d="M16.183 18.905c.065.483.067 1.131.067 2.095v.931C15.094 22 13.7 22 12 22s-3.094 0-4.25-.069V21c0-.964.002-1.612.067-2.095c.062-.461.169-.659.3-.789s.327-.237.788-.3c.483-.064 1.131-.066 2.095-.066h2c.964 0 1.612.002 2.095.067c.461.062.659.169.789.3s.237.327.3.788"></path>
    </svg>
  );
}
function BuilderAddIcon({size=18}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" fillRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m.75-13a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25z" clipRule="evenodd"></path>
    </svg>
  );
}
function BuilderCopyIcon({size=14}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" d="M7 7c0-2.828 0-4.243.879-5.121C8.757 1 10.172 1 13 1h4c2.828 0 4.243 0 5.121.879C23 2.757 23 4.172 23 7v4c0 2.828 0 4.243-.879 5.121C21.243 17 19.828 17 17 17h-4c-2.828 0-4.243 0-5.121-.879C7 15.243 7 13.828 7 11z" opacity=".5"></path>
      <path fill="currentColor" d="M1 13c0-2.828 0-4.243.879-5.121C2.757 7 4.172 7 7 7h4c2.828 0 4.243 0 5.121.879C17 8.757 17 10.172 17 13v4c0 2.828 0 4.243-.879 5.121C15.243 23 13.828 23 11 23H7c-2.828 0-4.243 0-5.121-.879C1 21.243 1 19.828 1 17z"></path>
    </svg>
  );
}
function BuilderTestIcon({size=14}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10" opacity=".35"></path>
      <path fill="currentColor" d="M10.2 8.5c0-.66.72-1.07 1.29-.74l4.81 2.78c.57.33.57 1.15 0 1.48l-4.81 2.78c-.57.33-1.29-.08-1.29-.74z"></path>
    </svg>
  );
}
function BuilderValidateIcon({size=14}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" d="M10 3a7 7 0 1 1-4.4 12.4L2.5 18.5 1 17l3.1-3.1A7 7 0 0 1 10 3m0 2a5 5 0 1 0 0 10a5 5 0 0 0 0-10"></path>
    </svg>
  );
}
function BuilderDeleteIcon({size=14}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0}}>
      <path fill="currentColor" d="M9 3h6l1 2h4v2H4V5h4z" opacity=".55"></path>
      <path fill="currentColor" d="M6 8h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm4 3v7h2v-7zm4 0v7h2v-7z"></path>
    </svg>
  );
}
function BuilderPaletteIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M12 2C6.48 2 2 6.03 2 11c0 2.65 1.64 4.17 3.86 4.17h1.58c.86 0 1.56.7 1.56 1.56v.67c0 1.77 1.43 3.2 3.2 3.2H12c5.52 0 10-4.48 10-10S17.52 2 12 2" opacity=".35"></path>
      <circle cx="7.7" cy="10.2" r="1.25" fill="currentColor"></circle>
      <circle cx="10.7" cy="7.5" r="1.25" fill="currentColor"></circle>
      <circle cx="14.6" cy="7.7" r="1.25" fill="currentColor"></circle>
      <circle cx="17" cy="10.9" r="1.25" fill="currentColor"></circle>
    </svg>
  );
}
function BuilderFileIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M6 2h8l4 4v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2" opacity=".35"></path>
      <path fill="currentColor" d="M14 2v4h4M8 11h8v1.5H8zm0 3.5h8V16H8z"></path>
    </svg>
  );
}
function BuilderToolsIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M5.2 3.9 3.8 5.3l3 3L8.2 7zM16 5l3 3-8.8 8.8-3-3z" opacity=".35"></path>
      <path fill="currentColor" d="M18.6 10.6 20 12l-1.5 1.5 1.8 1.8-1.4 1.4-1.8-1.8L15.6 16l-1.4-1.4zM6.8 15.5l1.7 1.7-3.1 3.1H3.7v-1.7z"></path>
    </svg>
  );
}
function BuilderRouteIcon({size=16,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M4 6a2 2 0 1 1 4 0v1h2.5A4.5 4.5 0 0 1 15 11.5v1h1a2 2 0 1 1 0 2h-1v1A4.5 4.5 0 0 1 10.5 20H8v1a2 2 0 1 1-2-2v-1a2 2 0 0 1 2-2h2.5a2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 10.5 10H8v1a2 2 0 1 1-2-2V8a2 2 0 0 1-2-2"></path>
    </svg>
  );
}
function BuilderExportIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M4 5h16v5h-2V7H6v10h6v2H4z" opacity=".35"></path>
      <path fill="currentColor" d="M13 11h4V8l5 4-5 4v-3h-4z"></path>
    </svg>
  );
}
function BuilderLockIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M6 10V8a6 6 0 1 1 12 0v2h1a1 1 0 0 1 1 1v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a1 1 0 0 1 1-1zM8 8v2h8V8a4 4 0 1 0-8 0" opacity=".35"></path>
      <circle cx="12" cy="15.5" r="1.8" fill="currentColor"></circle>
    </svg>
  );
}
function BuilderCodeIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}}>
      <path fill="currentColor" d="M8 4l-6 8 6 8" opacity=".35"></path>
      <path fill="currentColor" d="M16 4l6 8-6 8"></path>
      <path fill="currentColor" d="M14.5 7.5L9.5 16.5" opacity=".6"></path>
    </svg>
  );
}
function BuilderRefreshIcon({size=12,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M17 4v3h-3M7 20v-3h3"></path>
    </svg>
  );
}
function BuilderInboundIcon({size=14,color='currentColor'}){
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{display:'inline-flex',verticalAlign:'middle',flexShrink:0,color}} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v11m0 0l-3.5-3.5M12 14l3.5-3.5"></path>
      <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"></path>
    </svg>
  );
}

// ── Camel step-type icon set — one recognizable line glyph per EIP/processor,
// rendered with currentColor so callers can tint via a wrapping `color` style
// (most callers already set `--accent`/`accentColor` on the wrapper). Falls
// back to a plain gear for anything unmapped. Never stored on step objects
// (see iconForStep) — purely a render-time lookup so it can't leak into the
// JSON-serialized flowDefinition payload.
function StepIconSvg({name, size=16, color='currentColor'}){
  const s = {display:'inline-flex',verticalAlign:'middle',flexShrink:0,color};
  const wrap = (children) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={s} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
  );
  switch(name){
    case 'from':
      return wrap(<path d="M7 4l13 8-13 8z" fill="currentColor" stroke="none"></path>);
    case 'log':
      return wrap(<><rect x="4" y="3" width="16" height="18" rx="2"></rect><path d="M8 8h8M8 12h8M8 16h5"></path></>);
    case 'setBody':
      return wrap(<><path d="M6 3h8l4 4v14H6z"></path><path d="M9 13l7-7 2 2-7 7H9z"></path></>);
    case 'setHeader': case 'setHeaders':
      return wrap(<><path d="M3 11l8-8h5a2 2 0 0 1 2 2v5l-8 8a2 2 0 0 1-3 0l-4-4a2 2 0 0 1 0-3z"></path><circle cx="15" cy="9" r="1.2" fill="currentColor" stroke="none"></circle></>);
    case 'removeHeader': case 'removeHeaders': case 'removeProperty':
      return wrap(<><path d="M3 11l8-8h5a2 2 0 0 1 2 2v5l-8 8a2 2 0 0 1-3 0l-4-4a2 2 0 0 1 0-3z"></path><path d="M12.5 9.5l3 3m0-3l-3 3"></path></>);
    case 'setProperty': case 'setVariable':
      return wrap(<><path d="M3 11l8-8h5a2 2 0 0 1 2 2v5l-8 8a2 2 0 0 1-3 0l-4-4a2 2 0 0 1 0-3z"></path><circle cx="14.5" cy="9.5" r="1.4" fill="currentColor" stroke="none"></circle></>);
    case 'setExchangePattern':
      return wrap(<path d="M7 7h10m0 0l-3-3m3 3l-3 3M17 17H7m0 0l3 3m-3-3l3-3"></path>);
    case 'transform':
      return wrap(<path d="M21 7.5a4.5 4.5 0 0 1-6.1 4.2L9 17.6a2 2 0 1 1-2.8-2.8l5.9-5.9A4.5 4.5 0 0 1 16.5 3a4.5 4.5 0 0 1 3.9 2"></path>);
    case 'to': case 'toD':
      return wrap(<><rect x="3" y="5" width="9" height="14" rx="1.5"></rect><path d="M13 12h8m0 0l-3-3m3 3l-3 3"></path></>);
    case 'choice':
      return wrap(<path d="M12 4v6M12 10l-6 6M12 10l6 6M6 16v3M18 16v3"></path>);
    case 'filter':
      return wrap(<path d="M4 5h16l-6 8v6l-4-2v-4z"></path>);
    case 'split':
      return wrap(<><circle cx="6" cy="6" r="2"></circle><circle cx="6" cy="18" r="2"></circle><path d="M7.5 7.5L20 20M7.5 16.5L20 4"></path></>);
    case 'aggregate':
      return wrap(<path d="M4 6l6 6-6 6M20 6l-6 6 6 6M10 12h4"></path>);
    case 'multicast':
      return wrap(<><circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none"></circle><path d="M8.3 8.3a5.2 5.2 0 0 0 0 7.4M15.7 8.3a5.2 5.2 0 0 1 0 7.4M5 5a9.6 9.6 0 0 0 0 14M19 5a9.6 9.6 0 0 1 0 14"></path></>);
    case 'marshal':
      return wrap(<><path d="M4 8l8-4 8 4-8 4-8-4z"></path><path d="M4 8v8l8 4 8-4V8"></path></>);
    case 'unmarshal':
      return wrap(<><path d="M4 8l8-4 8 4-8 4-8-4z"></path><path d="M4 8v8l8 4 8-4V8"></path><path d="M12 20v-7m0 0l-2.3 2.3M12 13l2.3 2.3"></path></>);
    case 'delay':
      return wrap(<><circle cx="12" cy="13" r="8"></circle><path d="M12 9v4l3 2M9 2h6"></path></>);
    case 'loop':
      return wrap(<path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M17 4v3h-3M7 20v-3h3"></path>);
    case 'throttle':
      return wrap(<><path d="M4 16a8 8 0 1 1 16 0"></path><path d="M12 16l4-5"></path><circle cx="12" cy="16" r="1.2" fill="currentColor" stroke="none"></circle></>);
    case 'doTry':
      return wrap(<path d="M12 3l7 3v6c0 5-3 7.5-7 9-4-1.5-7-4-7-9V6z"></path>);
    case 'doCatch':
      return wrap(<><path d="M12 3l7 3v6c0 5-3 7.5-7 9-4-1.5-7-4-7-9V6z"></path><path d="M12 8.5v4M12 15.5h.01"></path></>);
    case 'doFinally':
      return wrap(<><path d="M12 3l7 3v6c0 5-3 7.5-7 9-4-1.5-7-4-7-9V6z"></path><path d="M9 12l2 2 4-4"></path></>);
    case 'bean':
      return wrap(<><path d="M4 9h13a3 3 0 0 1 0 6h-1"></path><path d="M4 9v7a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V9"></path><path d="M7 6c0-1 1-1 1-2s-1-1-1-2M11 6c0-1 1-1 1-2s-1-1-1-2"></path></>);
    case 'script':
      return wrap(<><path d="M7 3h9a2 2 0 0 1 2 2v13.5a1.5 1.5 0 0 1-3 0V6H7a2 2 0 1 0 0 4h7"></path><path d="M7 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2"></path></>);
    case 'process':
      return wrap(<><circle cx="12" cy="12" r="3.1"></circle><path d="M12 2.5v3M12 18.5v3M4.2 6.2l2 2M17.8 15.8l2 2M2.5 12h3M18.5 12h3M4.2 17.8l2-2M17.8 8.2l2-2"></path></>);
    case 'wireTap':
      return wrap(<><circle cx="10" cy="10" r="6"></circle><path d="M14.5 14.5L20 20"></path><circle cx="10" cy="10" r="1.3" fill="currentColor" stroke="none"></circle></>);
    case 'enrich':
      return wrap(<><path d="M12 3c3 4 5 6.5 5 9.5A5 5 0 1 1 7 12.5C7 9.5 9 7 12 3z"></path><path d="M12 11v4M10 13h4"></path></>);
    case 'pollEnrich':
      return wrap(<><path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M17 4v3h-3M7 20v-3h3"></path><path d="M12 10v4M10 12h4"></path></>);
    case 'convertBodyTo':
      return wrap(<><rect x="2" y="4" width="7" height="9" rx="1"></rect><rect x="15" y="11" width="7" height="9" rx="1"></rect><path d="M9 8.5h6m0 0l-2-2m2 2l-2 2"></path></>);
    case 'recipientList':
      return wrap(<><path d="M4 6h11M4 12h11M4 18h7"></path><circle cx="19" cy="18" r="2.3"></circle><path d="M18 18l.8.8L20 17.6"></path></>);
    case 'routingSlip':
      return wrap(<><path d="M4 6l6-2 6 2 4-2v14l-4 2-6-2-6 2z"></path><path d="M10 4v14M16 6v14"></path></>);
    case 'dynamicRouter':
      return wrap(<><circle cx="12" cy="12" r="9"></circle><path d="M15 9l-4.5 1.5L9 15l4.5-1.5z" fill="currentColor" stroke="none"></path></>);
    case 'claimCheck':
      return wrap(<><path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.5a2 2 0 1 0 0 3V15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.5a2 2 0 1 0 0-3z"></path><path d="M9 7v10" strokeDasharray="2 2"></path></>);
    case 'idempotentConsumer':
      return wrap(<><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path><circle cx="12" cy="15.5" r="1.3" fill="currentColor" stroke="none"></circle></>);
    case 'resequence':
      return wrap(<><rect x="3" y="4.5" width="3" height="3" rx="0.6" fill="currentColor" stroke="none"></rect><rect x="3" y="10.5" width="3" height="3" rx="0.6" fill="currentColor" stroke="none"></rect><rect x="3" y="16.5" width="3" height="3" rx="0.6" fill="currentColor" stroke="none"></rect><path d="M9 6h11M9 12h11M9 18h11"></path></>);
    case 'sort':
      return wrap(<path d="M7 4v16M7 4L4 7M7 4l3 3M14 8h6M14 12h4M14 16h2"></path>);
    case 'threads':
      return wrap(<path d="M6 4v16M12 4v16M18 4v16"></path>);
    case 'saga':
      return wrap(<><circle cx="12" cy="12" r="8"></circle><circle cx="12" cy="12" r="4.3"></circle><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"></circle></>);
    case 'stop':
      return wrap(<><path d="M8 3h8l5 5v8l-5 5H8l-5-5V8z"></path><rect x="9" y="9" width="6" height="6" fill="currentColor" stroke="none"></rect></>);
    case 'rollback':
      return wrap(<><path d="M9 7L4 12l5 5"></path><path d="M4 12h10a5 5 0 1 0 0-10h-1"></path></>);
    default:
      return wrap(<><circle cx="12" cy="12" r="3.1"></circle><path d="M12 2.5v3M12 18.5v3M4.2 6.2l2 2M17.8 15.8l2 2M2.5 12h3M18.5 12h3M4.2 17.8l2-2M17.8 8.2l2-2"></path></>);
  }
}

/* ===== ROUTES EDITOR ===== */

/* ===== ROUTE INFO PANEL — crash-free, regex-based, no js-yaml parsing ===== */
const STEP_ICONS={
  log:'📝',setBody:'📄',setHeader:'🏷️',setVariable:'📌',to:'📤',toD:'📤',
  bean:'☕',choice:'🔀',split:'✂️',aggregate:'🔗',filter:'🔍',doTry:'🛡️',
  doCatch:'🪤',doFinally:'✅',delay:'⏱️',loop:'🔄',multicast:'📡',enrich:'💉',
  marshal:'🗜️',unmarshal:'📦',process:'⚙️',script:'📜',transform:'🔧',
  throttle:'🚦',wireTap:'🔎',convertBodyTo:'🔄',removeHeader:'🗑️',saga:'🎯',
  pollEnrich:'🔁',setExchangePattern:'🔃',
};
function parseRouteInfoFromYaml(yaml){
  // Extract route blocks using simple line scanning — no YAML parser needed
  const lines=yaml.split('\n');
  const routes=[];
  let cur=null;
  const stepRe=/^\s{4,6}-\s+(log|setBody|setHeader|setVariable|to:|toD:|bean|choice|split|aggregate|filter|doTry|doCatch|doFinally|delay|loop|multicast|enrich|marshal|unmarshal|process|script|transform|throttle|wireTap|convertBodyTo|removeHeader|saga|pollEnrich|setExchangePattern)[\s:]/;
  const knownStepKeys=Object.keys(STEP_ICONS);
  for(let i=0;i<lines.length;i++){
    const ln=lines[i];
    // Detect route id
    const ridM=ln.match(/^\s+id:\s+(\S+)/);
    if(ridM&&cur)cur.id=ridM[1];
    // Detect route description
    const descM=ln.match(/^\s+description:\s+"?([^"]+)"?/);
    if(descM&&cur&&!cur.description)cur.description=descM[1].trim();
    // Detect from uri
    const fromM=ln.match(/^\s+uri:\s+(\S+)/);
    if(fromM&&cur&&!cur.from)cur.from=fromM[1];
    // Detect new route
    if(/^\s*-\s+route\s*:/.test(ln)||/^-\s+route\s*:/.test(ln)){
      cur={id:'',description:'',from:'',steps:[]};
      routes.push(cur);
    }
    // Detect steps — look for known Camel step keys at step indent level
    if(cur){
      const stepMatch=ln.match(/^\s+-\s+(\w+)\s*:/);
      if(stepMatch&&knownStepKeys.includes(stepMatch[1]))cur.steps.push(stepMatch[1]);
    }
  }
  return routes;
}

function RouteInfoPanel({yaml,routeIds,routeStatuses}){
  const routes=useMemo(()=>{
    if(!yaml||!yaml.trim())return[];
    try{return parseRouteInfoFromYaml(yaml);}catch(e){return[];}
  },[yaml]);

  const statusColor=s=>{
    if(!s||s==='NOT_DEPLOYED')return{color:'#6b7280',bg:'rgba(107,114,128,0.1)',dot:'#6b7280'};
    if(s.startsWith('Started'))return{color:'#16a34a',bg:'rgba(22,163,74,0.1)',dot:'#22c55e'};
    if(s==='Stopped')return{color:'#dc2626',bg:'rgba(220,38,38,0.1)',dot:'#ef4444'};
    return{color:'#d97706',bg:'rgba(217,119,6,0.1)',dot:'#f59e0b'};
  };

  if(!routes.length&&!(routeIds||[]).length)return(
    <div style={{textAlign:'center',padding:'60px 20px',color:'var(--text3)'}}>
      <div style={{marginBottom:10,opacity:.4,display:'flex',justifyContent:'center'}}><BuilderRouteIcon size={40}/></div>
      <div style={{fontSize:13}}>No routes detected in this file</div>
    </div>
  );

  const displayRoutes=routes.length?routes:(routeIds||[]).map(id=>({id,description:'',from:'',steps:[]}));

  return(
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      {displayRoutes.map((route,ri)=>{
        const id=route.id||(routeIds&&routeIds[ri])||`route-${ri+1}`;
        const st=routeStatuses&&routeStatuses[id];
        const sc=statusColor(st);
        return(
          <div key={ri} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:12,overflow:'hidden',boxShadow:'var(--shadow-sm)'}}>
            {/* Header */}
            <div style={{padding:'10px 16px',background:'linear-gradient(135deg,#1e2140,#2d3158)',display:'flex',alignItems:'center',gap:10}}>
              <span style={{color:'#a5b4fc',display:'inline-flex'}}><BuilderRouteIcon size={16}/></span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:13,color:'#fff',fontFamily:'ui-monospace,monospace',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{id}</div>
                {route.description&&<div style={{fontSize:11,color:'rgba(255,255,255,.5)',marginTop:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{route.description}</div>}
              </div>
              {st&&<span style={{fontSize:11,padding:'3px 10px',borderRadius:12,background:sc.bg,color:sc.color,fontWeight:600,flexShrink:0,display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:sc.dot,display:'inline-block'}}/>
                {st}
              </span>}
            </div>
            {/* Body */}
            <div style={{padding:14,display:'flex',flexDirection:'column',gap:10}}>
              {/* FROM */}
              {route.from&&(
                <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:'rgba(34,197,94,0.08)',border:'1.5px solid rgba(34,197,94,0.25)',borderRadius:8}}>
                  <span style={{fontSize:15,flexShrink:0}}>▶️</span>
                  <div style={{minWidth:0,flex:1}}>
                    <div style={{fontWeight:700,fontSize:11,color:'#16a34a',fontFamily:'ui-monospace,monospace',marginBottom:2}}>FROM</div>
                    <div style={{fontSize:11.5,color:'#cdd6f4',fontFamily:'ui-monospace,monospace',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{route.from}</div>
                  </div>
                </div>
              )}
              {/* Steps summary */}
              {route.steps.length>0&&(
                <div>
                  <div style={{fontSize:11,fontWeight:600,color:'var(--text3)',marginBottom:6,textTransform:'uppercase',letterSpacing:'.5px'}}>Steps ({route.steps.length})</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
                    {route.steps.map((s,si)=>(
                      <span key={si} style={{fontSize:11.5,padding:'3px 9px',borderRadius:6,background:'var(--surface2)',border:'1px solid var(--border)',color:'var(--text2)',display:'inline-flex',alignItems:'center',gap:4,fontFamily:'ui-monospace,monospace'}}>
                        <span style={{display:'inline-flex'}}><StepIconSvg name={s} size={12}/></span>{s}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {!route.from&&!route.steps.length&&(
                <div style={{fontSize:12,color:'var(--text3)',textAlign:'center',padding:'8px 0'}}>No step details extracted — view YAML for full content</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* YAML Textarea editor — lightweight, no crashes */
function YamlEditor({value,onChange,readOnly}){
  const handleKeyDown=(e)=>{
    if(e.key==='Tab'){
      e.preventDefault();
      const ta=e.target;
      const s=ta.selectionStart,en=ta.selectionEnd;
      const nv=ta.value.substring(0,s)+'  '+ta.value.substring(en);
      onChange&&onChange(nv);
      requestAnimationFrame(()=>{ta.selectionStart=ta.selectionEnd=s+2;});
    }
  };
  return(
    <textarea
      value={value||''}
      onChange={e=>onChange&&onChange(e.target.value)}
      onKeyDown={readOnly?undefined:handleKeyDown}
      readOnly={!!readOnly}
      spellCheck={false}
      style={{
        width:'100%',height:'100%',padding:'14px 18px',
        background:'#1e1e2e',color:'#cdd6f4',
        fontFamily:'ui-monospace,"Cascadia Code","Fira Code",Consolas,monospace',
        fontSize:12.5,lineHeight:1.65,border:'none',outline:'none',
        resize:'none',boxSizing:'border-box',tabSize:2,
      }}
    />
  );
}

function NewRouteModal({onClose,onCreated,showToast}){
  const [name,setName]=useState('');
  const [loading,setLoading]=useState(false);
  const create=async()=>{
    if(!name.trim())return;
    let fname=name.trim();
    if(!fname.endsWith('.yaml')&&!fname.endsWith('.yml'))fname+='.camel.yaml';
    try{
      setLoading(true);
      await API('POST','/api/routes/files',{name:fname});
      showToast('Created '+fname,'success');
      onCreated(fname);
    }catch(e){showToast('Failed: '+e.message,'error');}
    finally{setLoading(false);}
  };
  return(
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal modal-sm">
        <div className="modal-header">
          <div><div className="modal-title">New Route File</div><div className="modal-subtitle">Creates a starter template in ./routes/</div></div>
          <button className="btn-icon btn-ghost" onClick={onClose}><CloseIcon size={14}/></button>




        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Route Name <span className="req">*</span></label>
            <input className="form-input" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. my-invoice-route" onKeyDown={e=>e.key==='Enter'&&create()} autoFocus/>
            <div className="form-hint">Extension <code>.camel.yaml</code> added automatically if omitted</div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={create} disabled={!name.trim()||loading}>{loading?'Creating…':'Create File'}</button>
        </div>
      </div>
    </div>
  );
}

// ── CATALOG STATE (loaded once) ─────────────────────────────────────────
//
// The catalog endpoints (/api/catalog/{processors,components,kamelets}) are
// served by CatalogController which lazily builds its caches from
// org.apache.camel.catalog.DefaultCamelCatalog. First call cold-starts the
// catalog (~3–10s); subsequent calls are <50ms. We give each fetch a generous
// 30s budget via AbortController so a slow first-call doesn't silently drop
// us to the 18-item built-in fallback list — the most common symptom users
// reported as "stuck with same 10 steps".
let _catalogCache = null;
async function fetchCatalogEndpoint(path, timeoutMs = 30000) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const r = await fetch(path, { method: 'GET', signal: ctrl.signal, headers: { 'Content-Type': 'application/json' } });
    if (!r.ok) throw new Error(path + ' → HTTP ' + r.status);
    return await r.json();
  } finally {
    clearTimeout(timer);
  }
}
async function loadCatalog() {
  if (_catalogCache) return _catalogCache;
  const errors = [];
  const safe = async (label, path) => {
    try {
      const data = await fetchCatalogEndpoint(path);
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.warn('[catalog] ' + path + ' failed:', err && err.message ? err.message : err);
      errors.push({ label, path, message: (err && err.message) || String(err) });
      return [];
    }
  };
  const [processors, components, kamelets] = await Promise.all([
    safe('processors', '/api/catalog/processors'),
    safe('components', '/api/catalog/components'),
    safe('kamelets',   '/api/catalog/kamelets'),
  ]);
  _catalogCache = {
    processors: processors || [],
    components: components || [],
    kamelets:   kamelets   || [],
    errors,
  };
  if (errors.length > 0) {
    console.warn('[catalog] loaded with ' + errors.length + ' failed endpoint(s):', errors);
  } else {
    console.info('[catalog] loaded — processors:' + processors.length
      + ' components:' + components.length + ' kamelets:' + kamelets.length);
  }
  return _catalogCache;
}

// ── YAML GENERATOR ───────────────────────────────────────────────────────
//
// Generates Camel 4.x YAML DSL by building a structured JS object tree and
// dumping it with jsyaml. This eliminates an entire class of indentation /
// escape bugs that used to plague the hand-rolled string emitter:
//
//   - "constant" shorthand getting blanked out on save
//   - description:/parameters: nested incorrectly causing "Uri should not contains
//     query parameters" deploy errors
//   - nested step containers (split.steps, choice.when[].steps, doCatch.steps)
//     getting truncated
//
// Round-trip guarantee: parseYamlToRouteDef -> generateCamelYaml -> parseYamlToRouteDef
// must yield a structurally equivalent routeDef.

// Languages that may appear as a top-level expression key inside a step
// (e.g. `simple: "${body}"` shorthand for `expression: { simple: ... }`).
const EXPR_LANGS = [
  'simple','constant','groovy','javascript','jsonpath','xpath','xquery','xtokenize',
  'jq','spel','exchangeProperty','header','property','tokenize','language','ognl',
  'mvel','python','ruby','el','datasonnet','csimple'
];

// Steps whose body is a Camel expression (i.e. the user enters a single
// expression value plus a language). These are emitted as language shorthand
// `simple: "${...}"` rather than the verbose canonical expression block.
const EXPR_BODY_STEPS = new Set([
  'setBody','setHeader','setProperty','setVariable','transform','filter','split',
  'idempotentConsumer','loop','recipientList','resequence','aggregate','validate',
  'when','throttle','delay'
]);

function generateCamelYaml(routeDef) {
  if (!routeDef) return '';
  const route = {};
  route.id = routeDef.id || ('route-' + Date.now());
  if (routeDef.description) route.description = routeDef.description;
  if (routeDef.group) route.group = routeDef.group;

  const fromObj = { uri: (routeDef.from && routeDef.from.uri) || 'timer:trigger' };
  const fromParams = (routeDef.from && routeDef.from.params) || {};
  const cleanedParams = pruneEmpty(fromParams);
  if (Object.keys(cleanedParams).length > 0) fromObj.parameters = cleanedParams;
  const stepObjs = (routeDef.steps || []).map(stepToYamlObj).filter(Boolean);
  if (stepObjs.length > 0) fromObj.steps = stepObjs;
  route.from = fromObj;

  try {
    // Two-pass dump. The first pass emits everything inline (lineWidth: -1
    // means no wrapping) which is the right default for short URIs, setHeader
    // constants, etc. The second pass repairs multi-line strings — e.g. SOAP
    // envelopes carried by `setBody: { constant: | ... }` block scalars,
    // recipe `description: |` blocks — that would otherwise be escaped into
    // a single ugly inline string with literal "\n" sequences.
    //
    // Why two passes (vs configuring js-yaml's `styles` option): js-yaml's
    // styles option picks a style per YAML tag, not per node, so we can't
    // express "block for multiline, plain for single-line." The post-process
    // regex matches the inline-escaped form `key: "...\n..."` and rewrites
    // it to `key: |` block style with the correct indentation.
    const inline = jsyaml.dump([{ route }], {
      lineWidth: -1,
      noRefs: true,
      noCompatMode: true,
      quotingType: '"',
      forceQuotes: false,
    });
    const restored = restoreBlockScalars(inline);
    return restored.replace(/\n+$/, '');
  } catch (e) {
    console.warn('generateCamelYaml: jsyaml.dump failed', e, route);
    return '# YAML generation failed: ' + e.message;
  }
}

// Convert any `KEY: "...\n..."` inline string into a `KEY: |` block scalar.
// js-yaml dump with lineWidth: -1 collapses multiline strings into escaped
// inline form (`"<?xml version=\"1.0\"?>\n<root>..."`). That's valid YAML but
// destroys readability for SOAP envelopes, JSON bodies, and `description: |`
// blocks. This pass rewrites them to block-literal style without changing
// the parsed value. Safe to chain after js-yaml: parsing the rewritten YAML
// produces the same string.
function restoreBlockScalars(yamlText) {
  if (!yamlText || yamlText.indexOf('\\n') < 0) return yamlText;
  const lines = yamlText.split('\n');
  const out = [];
  for (const line of lines) {
    // Match: `<indent><key>: "<string with \n and possibly \"..."`
    // The string must contain at least one \n (escaped) — otherwise no need
    // to block-ify. Use a capturing regex to extract indent + key + value.
    const m = line.match(/^(\s*)([^:\n]+):\s*"((?:[^"\\]|\\.)*\\n(?:[^"\\]|\\.)*)"\s*$/);
    if (!m) { out.push(line); continue; }
    const [, indent, key, escaped] = m;
    // Unescape JS-style escapes (\\n → \n, \\" → ", \\\\ → \\, etc.).
    let decoded;
    try {
      decoded = JSON.parse('"' + escaped + '"');
    } catch (e) {
      // If JSON.parse can't decode the escape sequence (rare — js-yaml may
      // have emitted YAML-only escapes), leave the line alone.
      out.push(line);
      continue;
    }
    // Block-literal style requires each line indented at least 1 level deeper
    // than the key. Use the existing indent + 2 spaces.
    const childIndent = indent + '  ';
    out.push(indent + key + ': |');
    const valueLines = decoded.split('\n');
    // Trailing newline in source → empty final element; trim it so we don't
    // emit a dangling blank line. The `|` style preserves a single trailing
    // newline by default, which matches what most hand-written YAML has.
    if (valueLines.length > 0 && valueLines[valueLines.length - 1] === '') {
      valueLines.pop();
    }
    for (const vl of valueLines) out.push(childIndent + vl);
  }
  return out.join('\n');
}

// Convert one editor step into a Camel YAML JS object: { stepName: {...config...} }.
function stepToYamlObj(step) {
  if (!step || !step.stepName) return null;
  const body = stepConfigToYamlObj(step.stepName, step.config || {});
  return { [step.stepName]: body };
}

// Build the inside-of-the-step object. This is the inverse of parseStepConfig
// and is responsible for re-emitting:
//   - expression body shorthand:  { simple: "${...}" }
//   - container children:         { steps: [...] }, { when: [...] }, { otherwise: { steps: [...] } },
//                                 { doCatch: [{exception, steps}], doFinally: { steps } }
//   - everything else (uri, parameters, description, headers[], json/library, ...) is
//     passed through as-is so nested objects/arrays survive the round-trip intact.
function stepConfigToYamlObj(stepName, cfg) {
  // Shorthand step bodies that were a scalar in the source YAML.
  if (cfg && cfg.__scalar !== undefined) return cfg.__scalar;
  if (cfg && cfg.__array !== undefined) return cfg.__array;

  const out = {};

  // ── 1. Determine the expression body (if any) ─────────────────────────────
  // Single canonical model: ALL expression-bearing steps use {language, expression}.
  // setHeader/setProperty/setVariable additionally have a `name` sibling but the
  // expression itself is read from cfg.language + cfg.expression � same as
  // setBody/transform/split/filter. The legacy {type, value} dual-write is gone;
  // the form panel and parser are aligned on the canonical names.
  const lang = cfg.language || '';
  const exprValue = cfg.expression !== undefined ? cfg.expression : '';

  // Container keys handled separately, never passed through verbatim.
  const CONTAINER_KEYS = new Set(['_steps','when','otherwise','doCatch','doFinally','__scalar','__array']);

  // Per-step list of cfg keys that get consumed by expression-body emission.
  // ONLY strip these if they were actually used � otherwise pass through. This
  // prevents the previous bug where convertBodyTo.type and script.language got
  // silently dropped because they happened to share names with expression keys.
  const consumedExprKeys = new Set();
  if (EXPR_BODY_STEPS.has(stepName)) {
    consumedExprKeys.add('language');
    consumedExprKeys.add('expression');
  }

  // ── 2. Pass-through every non-special config key ──────────────────────────
  // For setHeader/setProperty/setVariable, cfg.name passes through here.
  // For container steps, _steps/when/otherwise/doCatch are emitted below.
  // For everything else, nested objects/arrays survive intact (no JSON.stringify
  // � that was the root cause of the original Builder-save data-loss bug).
  for (const [k, v] of Object.entries(cfg)) {
    if (CONTAINER_KEYS.has(k)) continue;
    if (consumedExprKeys.has(k)) continue;
    if (v === '' || v == null) continue;
    out[k] = v;
  }

  // ── 2b. For `to:` / `toD:`, pack non-DSL keys into a `parameters:` block ──
  // Inverse of the hoist done in parseStepConfig. Anything not in the DSL
  // top-level allow-list is a component option (httpMethod, httpUri,
  // connectTimeout, …) and must live inside `parameters:` so Camel can
  // construct the endpoint URI correctly.
  if (stepName === 'to' || stepName === 'toD') {
    const dslKeys = stepName === 'to' ? TO_DSL_KEYS : TOD_DSL_KEYS;
    const params = (out.parameters && typeof out.parameters === 'object' && !Array.isArray(out.parameters))
        ? { ...out.parameters } : {};
    delete out.parameters;
    for (const k of Object.keys(out)) {
      if (dslKeys.has(k)) continue;
      params[k] = out[k];
      delete out[k];
    }
    if (Object.keys(params).length > 0) out.parameters = params;
  }

  // ── 3. Emit expression body as language shorthand ─────────────────────────
  if (EXPR_BODY_STEPS.has(stepName)) {
    if (lang && exprValue !== '') {
      out[lang] = exprValue;
    } else if (exprValue !== '') {
      out['simple'] = exprValue; // sensible default when language was omitted
    }
    // If neither lang nor value is set, omit the expression entirely � Camel
    // will fail at deploy with a clearer error than us guessing.
  }

  // ── 4. Emit container children ────────────────────────────────────────────
  if (Array.isArray(cfg._steps) && cfg._steps.length > 0) {
    out.steps = cfg._steps.map(stepToYamlObj).filter(Boolean);
  }

  if (stepName === 'choice') {
    if (Array.isArray(cfg.when)) {
      out.when = cfg.when.map(w => {
        const wlang = w.language || 'simple';
        const wval = w.expression || '';
        const wObj = {};
        if (wval !== '') wObj[wlang] = wval;
        if (Array.isArray(w._steps) && w._steps.length > 0) {
          wObj.steps = w._steps.map(stepToYamlObj).filter(Boolean);
        }
        return wObj;
      });
    }
    if (cfg.otherwise) {
      const oObj = {};
      if (Array.isArray(cfg.otherwise._steps) && cfg.otherwise._steps.length > 0) {
        oObj.steps = cfg.otherwise._steps.map(stepToYamlObj).filter(Boolean);
      }
      out.otherwise = oObj;
    }
  }

  if (stepName === 'doTry') {
    if (Array.isArray(cfg.doCatch)) {
      out.doCatch = cfg.doCatch.map(c => {
        const cObj = {};
        if (Array.isArray(c.exception) && c.exception.length) cObj.exception = c.exception;
        if (Array.isArray(c._steps) && c._steps.length > 0) {
          cObj.steps = c._steps.map(stepToYamlObj).filter(Boolean);
        }
        return cObj;
      });
    }
    if (cfg.doFinally) {
      const fObj = {};
      if (Array.isArray(cfg.doFinally._steps) && cfg.doFinally._steps.length > 0) {
        fObj.steps = cfg.doFinally._steps.map(stepToYamlObj).filter(Boolean);
      }
      out.doFinally = fObj;
    }
  }

  return out;
}

function pruneEmpty(obj) {
  if (!obj || typeof obj !== 'object') return {};
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === '' || v == null) continue;
    out[k] = v;
  }
  return out;
}

// Legacy export shims � some callers still reference the old function names.
// They now delegate to the structured emitter so nothing breaks.
function generateStepYaml(step, indentN) {
  const obj = stepToYamlObj(step);
  if (!obj) return '';
  try {
    const dumped = jsyaml.dump([obj], { lineWidth: -1, noRefs: true, noCompatMode: true, quotingType: '"', forceQuotes: false });
    // Re-indent the dump output to match the requested nesting level.
    const pad = ' '.repeat(indentN);
    return dumped.split('\n').filter(l => l.length > 0).map(l => pad + l).join('\n');
  } catch (e) {
    console.warn('generateStepYaml failed', e);
    return '';
  }
}

// ── STEP NODE COLORS ─────────────────────────────────────────────────────
function getNodeColor(stepName, catalogType) {
  if (catalogType === 'kamelet') return '#db2777';
  if (catalogType === 'component') return '#16a34a';
  const routing = ['choice','filter','split','aggregate','multicast','recipientList','routingSlip'];
  const transform = ['setBody','setHeader','removeHeader','transform','marshal','unmarshal','convertBodyTo','enrich','pollEnrich'];
  const control = ['log','delay','loop','throttle','wireTap'];
  const error = ['doTry','doCatch','doFinally'];
  const messaging = ['to','toD','direct','seda'];
  if (routing.includes(stepName)) return '#7c3aed';
  if (transform.includes(stepName)) return '#2563eb';
  if (control.includes(stepName)) return '#d97706';
  if (error.includes(stepName)) return '#dc2626';
  if (messaging.includes(stepName)) return '#16a34a';
  return '#475569';
}

// ── STEP ICON MAP ─────────────────────────────────────────────────────────
const STEP_DISPLAY = {
  log:{icon:'📝',label:'Log'}, setBody:{icon:'📄',label:'Set Body'}, setHeader:{icon:'🏷️',label:'Set Header'},
  removeHeader:{icon:'🗑️',label:'Remove Header'}, removeHeaders:{icon:'🗑️',label:'Remove Headers'},
  setHeaders:{icon:'🏷️',label:'Set Headers'}, setProperty:{icon:'📌',label:'Set Property'},
  setExchangePattern:{icon:'🔃',label:'Set Exchange Pattern'},
  transform:{icon:'🔧',label:'Transform'},
  to:{icon:'📤',label:'To'}, toD:{icon:'📤',label:'To Dynamic'}, choice:{icon:'🔀',label:'Choice'},
  filter:{icon:'🔍',label:'Filter'}, split:{icon:'✂️',label:'Split'}, aggregate:{icon:'🔗',label:'Aggregate'},
  multicast:{icon:'📡',label:'Multicast'}, marshal:{icon:'🗜️',label:'Marshal'}, unmarshal:{icon:'📦',label:'Unmarshal'},
  delay:{icon:'⏱️',label:'Delay'}, loop:{icon:'🔄',label:'Loop'}, throttle:{icon:'🚦',label:'Throttle'},
  doTry:{icon:'🛡️',label:'Do Try'}, doCatch:{icon:'🪤',label:'Do Catch'}, doFinally:{icon:'✅',label:'Do Finally'},
  bean:{icon:'☕',label:'Bean'}, script:{icon:'📜',label:'Script'}, process:{icon:'⚙️',label:'Process'},
  wireTap:{icon:'🔎',label:'Wire Tap'}, enrich:{icon:'💉',label:'Enrich'}, pollEnrich:{icon:'🔁',label:'Poll Enrich'},
  convertBodyTo:{icon:'🔄',label:'Convert Body'}, setVariable:{icon:'📌',label:'Set Variable'},
  recipientList:{icon:'📋',label:'Recipient List'}, routingSlip:{icon:'🗺️',label:'Routing Slip'},
  dynamicRouter:{icon:'🧭',label:'Dynamic Router'}, claimCheck:{icon:'🎫',label:'Claim Check'},
  idempotentConsumer:{icon:'🔒',label:'Idempotent Consumer'}, resequence:{icon:'🔢',label:'Resequence'},
  sort:{icon:'🔤',label:'Sort'}, threads:{icon:'🧵',label:'Threads'},
  saga:{icon:'🎯',label:'Saga'}, stop:{icon:'⏹️',label:'Stop'},
  rollback:{icon:'↩️',label:'Rollback'}, removeProperty:{icon:'🗑️',label:'Remove Property'},
};

// Detect whether a value looks like an image URL (catalog metadata may carry an
// HTTP url, a data: URI, or a relative path). Anything that's a single emoji /
// short text falls through to plain-text rendering.
function isIconUrl(v) {
  if (!v || typeof v !== 'string') return false;
  return /^(https?:|data:|\.?\/)/i.test(v) || /\.(svg|png|jpe?g|gif|webp)(\?|$)/i.test(v);
}

// Resolve a step's icon for display. May return either a JSX element (an <img>
// when the catalog item carries a real icon URL) or a plain string (emoji from
// STEP_DISPLAY / catalog scalar). Callers render with {iconForStep(step)} —
// React handles both transparently.
//
// We always re-derive from `stepName` rather than blindly trusting `step.icon`
// because the stored icon can come back corrupted from a JSON round-trip
// (UTF-8 emoji bytes mangled into "||" or similar). We support both camelCase
// (`setHeader`) and kebab-case (`set-header`) since Camel YAML accepts both.
function iconForStep(step, size=18) {
  if (!step) return <StepIconSvg name="_default" size={size}/>;
  // `step.icon` may be a URL (catalog meta with full-color artwork) or an
  // emoji glyph (hand-authored). We also probe a few common alt URL fields
  // so backend variants that ship richer metadata work without another
  // frontend change.
  for (const u of [step.icon, step.iconUrl, step.catalogIcon, step.iconRef, step.imageUrl]) {
    if (isIconUrl(u)) {
      return <img src={u} alt="" style={{width:size,height:size,objectFit:'contain',verticalAlign:'middle'}}/>;
    }
  }
  const raw = step.stepName || step.name || '';
  const camel = raw.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  // Prefer the dedicated line-icon set (keyed the same as STEP_DISPLAY) so
  // the canvas renders crisp SVGs instead of platform-dependent emoji.
  if (STEP_DISPLAY[camel]) return <StepIconSvg name={camel} size={size}/>;
  if (STEP_DISPLAY[raw]) return <StepIconSvg name={raw} size={size}/>;
  return <StepIconSvg name="_default" size={size}/>;
}

// ── Step-card label helpers ──────────────────────────────────────────────
// These produce the two lines of text shown on every step card:
//   formatStepLabel(step)   → the headline (e.g. "split", "setHeader", "to")
//   formatStepDetail(step)  → a one-line config preview (e.g. "uri: https…")
// Both are pure functions of the step object — no React, no side effects —
// so they can be safely called inside render. They are designed to never
// throw on malformed input; if the step is weird, they return a short
// fallback string instead.

function formatStepLabel(step) {
  if (!step) return '(empty step)';
  // Karavan-style label resolution: the YAML `description:` field is where
  // authors put human-readable intent (e.g. "🔑 Authenticate with TaxLab ASP"),
  // so it should win over the technical step type. parseStep stores it under
  // step.config.description; top-level step.description is also checked for
  // older / hand-built step shapes. Plain-string guard prevents
  // "[object Object]" if the YAML stuffs a structured description in there.
  const cfgDesc = step.config && typeof step.config.description === 'string' ? step.config.description.trim() : '';
  if (cfgDesc) return cfgDesc;
  if (typeof step.description === 'string' && step.description.trim()) return step.description.trim();
  // step.title is the proper-cased step-type label from STEP_DISPLAY
  // ("Set Header", "Unmarshal" etc.) — the technical fallback when no
  // author description is provided.
  if (typeof step.title === 'string' && step.title.trim()) return step.title.trim();
  return step.stepName || step.name || '(unknown step)';
}

function formatStepDetail(step) {
  if (!step || !step.config) return '';
  const cfg = step.config;
  // Pick the most-informative single config field for the step type.
  // Falls through to a generic "first two entries" preview if nothing
  // specific matches — that way custom / unknown step types still show
  // something useful instead of a blank line.
  const name = step.stepName || '';
  // Endpoint-style steps — show the URI prominently.
  if (cfg.uri) return 'uri: ' + String(cfg.uri).substring(0, 60);
  // setHeader / setProperty / setVariable — show `name=value` (value can
  // be a literal or an expression block).
  if (name === 'setHeader' || name === 'setProperty' || name === 'setVariable' || name === 'set-header') {
    const k = cfg.name || '?';
    const v = cfg.constant != null ? cfg.constant
            : cfg.simple   != null ? '${' + cfg.simple + '}'
            : (cfg.expression && typeof cfg.expression === 'object'
                ? (cfg.expression.constant && (cfg.expression.constant.expression || cfg.expression.constant))
               || (cfg.expression.simple   && (cfg.expression.simple.expression   || cfg.expression.simple))
               || ''
               : (cfg.value || ''));
    return k + (v ? ' = ' + String(v).substring(0, 50) : '');
  }
  // log — show the message.
  if (name === 'log' && cfg.message) return String(cfg.message).substring(0, 60);
  // split / filter / loop / aggregate — show the expression.
  if (cfg.simple) return 'simple: ${' + String(cfg.simple).substring(0, 50) + '}';
  if (cfg.expression && typeof cfg.expression === 'object') {
    const e = cfg.expression;
    const k = Object.keys(e).find(k => k !== 'id');
    if (k) {
      const inner = e[k];
      const s = typeof inner === 'string' ? inner
              : (inner && (inner.expression || inner.simple || inner.constant)) || '';
      return k + ': ' + String(s).substring(0, 50);
    }
  }
  // unmarshal / marshal — show the format.
  if (name === 'unmarshal' || name === 'marshal') {
    if (cfg.json) return 'json' + (cfg.json.library ? ' (' + cfg.json.library + ')' : '');
    const fmt = Object.keys(cfg).find(k => k !== 'id');
    if (fmt) return fmt;
  }
  // removeHeaders / removeHeader — show the pattern.
  if ((name === 'removeHeaders' || name === 'removeHeader') && cfg.pattern) {
    return 'pattern: ' + String(cfg.pattern).substring(0, 50);
  }
  // Generic fallback — first two non-id, non-private keys.
  const entries = Object.entries(cfg)
    .filter(([k, v]) => k !== 'id' && !k.startsWith('_') && v != null && typeof v !== 'object')
    .slice(0, 2);
  if (entries.length === 0) return '';
  return entries.map(([k, v]) => k + ': ' + String(v).substring(0, 25)).join(' · ');
}

// ── SVG ROUTE CANVAS (enhanced RouteInfoPanel) ───────────────────────────
function RouteCanvas({yaml, routeIds, routeStatuses}) {
  const routes = useMemo(() => {
    if (!yaml || !yaml.trim()) return [];
    try { return parseRouteInfoFromYaml(yaml); } catch(e) { return []; }
  }, [yaml]);

  const statusColor = s => {
    if (!s || s === 'NOT_DEPLOYED') return '#6b7280';
    if (s.startsWith('Started')) return '#22c55e';
    if (s === 'Stopped') return '#ef4444';
    return '#f59e0b';
  };

  if (!routes.length && !(routeIds && routeIds.length)) return (
    <div style={{textAlign:'center',padding:'60px 20px',color:'var(--text3)'}}>
      <div style={{marginBottom:10,opacity:.4,display:'flex',justifyContent:'center'}}><BuilderRouteIcon size={40}/></div>
      <div style={{fontSize:13}}>No routes detected</div>
    </div>
  );

  const displayRoutes = routes.length ? routes : (routeIds||[]).map(id=>({id,description:'',from:'',steps:[]}));

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>
      {displayRoutes.map((route, ri) => {
        const id = route.id || (routeIds&&routeIds[ri]) || ('route-'+(ri+1));
        const st = routeStatuses && routeStatuses[id];
        const allSteps = [
          {type:'from', name: route.from||'unknown', iconName:'from', color:'#0891b2'},
          ...route.steps.map(s => ({type:'step', name:s, iconName:s, color: getNodeColor(s,'processor')}))
        ];
        const nodeH = 90;
        const totalH = allSteps.length * nodeH + 40;
        const cx = 120;

        return (
          <div key={ri} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:12,overflow:'hidden',boxShadow:'var(--shadow-sm)'}}>
            <div style={{padding:'10px 16px',background:'linear-gradient(135deg,#1e2140,#2d3158)',display:'flex',alignItems:'center',gap:10}}>
              <span style={{color:'#a5b4fc',display:'inline-flex'}}><BuilderRouteIcon size={16}/></span>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,fontSize:13,color:'#fff',fontFamily:'monospace'}}>{id}</div>
                {route.description && <div style={{fontSize:11,color:'rgba(255,255,255,.5)'}}>{route.description}</div>}
              </div>
              {st && <span style={{fontSize:11,padding:'3px 10px',borderRadius:12,background:'rgba(0,0,0,.3)',color:statusColor(st),fontWeight:600,display:'flex',alignItems:'center',gap:5}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:statusColor(st),display:'inline-block'}}/>
                {st}
              </span>}
            </div>
            <div style={{padding:16,background:'radial-gradient(circle,rgba(0,0,0,.04) 1px,transparent 1px)',backgroundSize:'20px 20px',overflowX:'auto'}}>
              <svg width={cx*2+40} height={totalH} style={{display:'block',margin:'0 auto',minWidth:200}}>
                <defs>
                  <marker id={'arrow-'+ri} markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
                    <path d="M0,0 L0,6 L8,3 z" fill="#4b5563"/>
                  </marker>
                </defs>
                {allSteps.map((node, ni) => {
                  const cy = ni * nodeH + 50;
                  const nextCy = (ni+1) * nodeH + 50;
                  return (
                    <g key={ni}>
                      {ni < allSteps.length-1 && (
                        <line x1={cx} y1={cy+28} x2={cx} y2={nextCy-28} stroke="#4b5563" strokeWidth={2} markerEnd={'url(#arrow-'+ri+')'}/>
                      )}
                      <circle cx={cx} cy={cy} r={28} fill={node.color} fillOpacity={0.15} stroke={node.color} strokeWidth={2}/>
                      <foreignObject x={cx-10} y={cy-10} width="20" height="20">
                        <div xmlns="http://www.w3.org/1999/xhtml" style={{width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',color:node.color}}>
                          <StepIconSvg name={node.iconName} size={18}/>
                        </div>
                      </foreignObject>
                      <text x={cx} y={cy+44} textAnchor="middle" fontSize={10} fill="#9ca3af" fontFamily="monospace">
                        {node.name.length > 16 ? node.name.substring(0,14)+'…' : node.name}
                      </text>
                    </g>
                  );
                })}
              </svg>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── STEP TREE WALKER (test pane's EmbeddedFlow) ──────────────────────────
//
// These backed the editor's own canvas until Kaoto replaced it. They survive
// because EmbeddedFlow — the view-only flow mirror inside the test pane —
// renders the same recursive LinearStep to show per-step run status.
//
// Container types whose children render inline under the parent card.
// Each of these uses a single `_steps[]` array in cfg, so the walker treats
// them uniformly. choice (when[] + otherwise._steps) and doTry (doCatch[] +
// doFinally._steps) have non-uniform child structures; they still render but
// children stay drill-in-only for now (deferred to a follow-up).
const SIMPLE_CONTAINERS = new Set([
  'split','filter','multicast','aggregate','loop','idempotentConsumer',
  'resequence','throttle','onCompletion','pipeline'
]);

/** Walk a routeDef.steps tree and yield a flat array of {step,depth,path}
 *  entries. `path` is an array of keys from `routeDef` down to the step,
 *  e.g. ['steps', 3] for top-level step 3 or
 *  ['steps', 3, 'config', '_steps', 7] for the 7th nested child of the
 *  3rd top-level step. The path is what mutation helpers walk.
 *  `parentPath` is the path to the array this step lives in
 *  (['steps'] for top-level, ['steps', 3, 'config', '_steps'] for nested). */
function walkRouteSteps(steps, depth, parentPath) {
  if (!Array.isArray(steps)) return [];
  const out = [];
  steps.forEach((step, idx) => {
    const path = [...parentPath, idx];
    out.push({ step, depth, path, parentPath, indexInParent: idx });
    if (step && SIMPLE_CONTAINERS.has(step.stepName)
        && step.config && Array.isArray(step.config._steps)
        && step.config._steps.length > 0) {
      out.push(...walkRouteSteps(
        step.config._steps,
        depth + 1,
        [...path, 'config', '_steps']
      ));
    }
  });
  return out;
}

/** Return a new copy of obj with the value at `path` replaced.
 *  Arrays are spread, objects are spread — pure functional update. */
function deepSet(obj, path, value) {
  if (path.length === 0) return value;
  const [head, ...rest] = path;
  if (Array.isArray(obj)) {
    const copy = obj.slice();
    copy[head] = deepSet(obj[head], rest, value);
    return copy;
  }
  return { ...(obj || {}), [head]: deepSet(obj ? obj[head] : undefined, rest, value) };
}

// ── Linear-mode tree renderer ────────────────────────────────────────────
// Karavan-style: compact circular icons, container steps render as outlined
// rounded rectangles with children INSIDE the box (not as flat siblings).
// For choice/doTry, branches (when/otherwise, try/doCatch/doFinally) render
// as side-by-side columns inside the parent container. The renderer is fully
// recursive — depth N container nests depth N+1 children, no flat-walker.
//
// Note: kept separate from the swimlane render (which still uses the flat
// walkRouteSteps walker for setBoxRef + SVG connector geometry). Swap is at
// the top of RouteBuilderCanvas based on canvasLayout state.

/** Branch-block summary header: "When · ${body[type]}=='IN'" / "Catch · IOException" */
function formatBranchHeader(kind, branch) {
  if (kind === 'when') {
    const exprObj = branch && branch.expression;
    const lang = exprObj && Object.keys(exprObj).find(k => k !== 'id');
    const val = lang && exprObj[lang] && (exprObj[lang].expression || exprObj[lang]);
    return val ? `When · ${String(val).substring(0, 40)}` : 'When';
  }
  if (kind === 'catch') {
    const ex = (branch && branch.exception) || [];
    return ex.length ? `Catch · ${ex.join(' | ')}` : 'Catch · Throwable';
  }
  return kind;
}

/** Recursive renderer. `ctx` carries handlers + shared state from
 *  RouteBuilderCanvas so we don't have to thread 10 callbacks. */
function LinearStep({step, depth, path, parentPath, indexInParent, siblingsLen, ctx}) {
  if (!step) return null;
  const { configStep, openConfig, openInspector, moveStepAtPath, deleteStepAtPath, readOnly, AddBtn,
          stepStatuses, pathToIndex, highlightedStepIdx } = ctx;
  const isContainer = SIMPLE_CONTAINERS.has(step.stepName);
  const isChoice    = step.stepName === 'choice';
  const isDoTry     = step.stepName === 'doTry';
  const cfg         = step.config || {};

  // Live test-run status (badge in the corner of the icon card). The path-to-
  // index map lets us look up this step's status from the SSE-driven
  // stepStatuses dict. PENDING (or undefined) = no badge; the card is
  // slightly faded so the user can tell the run hasn't reached it yet.
  const myStepIdx = pathToIndex ? pathToIndex.get(path.join('/')) : undefined;
  const runStatus = (stepStatuses && myStepIdx != null) ? stepStatuses[myStepIdx] : null;
  const isInspectorHighlighted = (highlightedStepIdx != null && myStepIdx === highlightedStepIdx);

  // Accent color — container types get strong brand colors so the
  // outlined boxes immediately read as "this is a Choice block" etc.
  let accent = step.color || '#475569';
  if (isChoice)    accent = '#7c3aed';   // purple — content router
  else if (isDoTry) accent = '#dc2626';   // red    — error handling
  else if (step.stepName === 'split')     accent = '#6366f1'; // indigo
  else if (step.stepName === 'filter')    accent = '#0891b2'; // cyan
  else if (step.stepName === 'multicast') accent = '#0891b2';
  else if (step.stepName === 'aggregate') accent = '#16a34a'; // green
  else if (step.stepName === 'loop')      accent = '#f59e0b'; // amber
  else if (['to','toD','wireTap','enrich','pollEnrich'].includes(step.stepName)) accent = '#16a34a'; // green = external

  const isHighlighted = configStep && configStep.path
    && configStep.path.length === path.length
    && configStep.path.every((p, i) => p === path[i]);
  const isLast = indexInParent === siblingsLen - 1;

  // Compact icon-first card — circle icon with label below. Click the card
  // body to edit config (canvas stays fully editable). The 👁 eye icon
  // appears in the bottom-right when a test run has captured data for this
  // step — clicking it opens the StepInspector with the raw input/output.
  const cardClass = `linear-icon-card`
    + (isHighlighted || isInspectorHighlighted ? ' is-active' : '')
    + (runStatus ? ' has-run-status' : '');
  // A step has inspectable test data once it has reached at least a
  // captured status — every status except undefined/null qualifies, even
  // RUNNING (the input is already known) and FAILED (error stack viewable).
  const hasInspectableData = runStatus && openInspector;
  // Tooltip differs by mode: in the editable canvas the card click opens
  // the config drawer; in the read-only test panel mirror it opens the
  // inspector (or does nothing if the step never ran).
  const cardTooltip = readOnly
    ? (hasInspectableData
        ? `${step.stepName} — ${formatStepLabel(step)}\nClick to inspect input / output`
        : `${step.stepName} — ${formatStepLabel(step)}\n(no captured data yet)`)
    : `${step.stepName} — ${formatStepLabel(step)}\nClick to configure`;
  const iconCard = (
    <div className={cardClass}
         style={{'--accent': accent, cursor: (readOnly && !hasInspectableData) ? 'default' : 'pointer'}}
         data-run-status={runStatus || ''}
         title={cardTooltip}
         onClick={() => openConfig(path, step)}>
      <div className="linear-icon-circle">
        {iconForStep(step,22)}
      </div>
      <div className="linear-icon-label">{formatStepLabel(step)}</div>
      {(() => {
        const detail = formatStepDetail(step);
        return detail ? <div className="linear-icon-sublabel">{detail}</div> : null;
      })()}
      {/* Live test status badge — only renders if a run has reached this step */}
      {runStatus && (
        <span className={`linear-run-badge ${runStatus.toLowerCase()}`}
              title={`Test status: ${runStatus}`}>
          {runStatus === 'RUNNING' ? '⟳'
            : runStatus === 'SUCCESS' ? '✓'
            : runStatus === 'FAILED' ? '✗'
            : runStatus === 'SKIPPED' ? '⊘'
            : '…'}
        </span>
      )}
      {/* 👁 Eye icon — opens StepInspector with raw input/output payloads.
          Only shown when there's captured test data for this step. Sits
          in the top-right corner so it doesn't collide with the status
          badge (bottom-right) or the hover-revealed move/delete actions
          (also top-right but only on hover). */}
      {hasInspectableData && (
        <button className="linear-eye-btn"
                onClick={e => { e.stopPropagation(); openInspector(path); }}
                title="View raw input / output for this step"
                aria-label="View raw test data">
          <EyeIcon size={13}/>
        </button>
      )}
      {!readOnly && (
        <div className="linear-icon-actions" onClick={e => e.stopPropagation()}>
          <button onClick={e => { e.stopPropagation(); moveStepAtPath(path, -1); }}
            disabled={indexInParent === 0} title="Move up">↑</button>
          <button onClick={e => { e.stopPropagation(); moveStepAtPath(path,  1); }}
            disabled={isLast} title="Move down">↓</button>
          <button onClick={e => { e.stopPropagation(); deleteStepAtPath(path); }}
            className="danger" title="Delete"><BuilderDeleteIcon size={12}/></button>
        </div>
      )}
    </div>
  );

  // Branch column for choice/doTry — header pill + vertical column of
  // child LinearSteps.
  const BranchColumn = ({label, branchAccent, steps, basePath}) => (
    <div className="linear-branch-col" style={{'--branch-accent': branchAccent || accent}}>
      <div className="linear-branch-header">{label}</div>
      <div className="linear-branch-body">
        {(steps || []).length === 0 && !readOnly && (
          <AddBtn parentPath={basePath} atIndex={0} isTail={true} compact={true}/>
        )}
        {(steps || []).map((s, i) => (
          <React.Fragment key={i}>
            {!readOnly && i === 0 && <AddBtn parentPath={basePath} atIndex={0} compact={true}/>}
            <LinearStep step={s} depth={depth+1}
              path={[...basePath, i]} parentPath={basePath}
              indexInParent={i} siblingsLen={steps.length} ctx={ctx}/>
            {/* AddBtn always renders — in edit mode it's the + insertion
                button; in readOnly the panel's AddBtn returns a rail
                (or null when isTail to avoid a dangling line). */}
            <AddBtn parentPath={basePath} atIndex={i+1} isTail={i === steps.length-1} compact={true}/>
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  return (
    <div className="linear-step-wrap">
      {iconCard}

      {/* Simple containers (split/filter/multicast/...) — children render
          inside a single bordered box, in a single vertical column. */}
      {isContainer && (
        <div className="linear-container-box" style={{'--accent': accent}}>
          <div className="linear-container-tag">{step.stepName.toUpperCase()}</div>
          <div className="linear-container-body">
            {(cfg._steps || []).length === 0 && !readOnly && (
              <div className="linear-empty-placeholder">
                <span style={{fontSize:10.5,color:'var(--text3)'}}>
                  Empty {step.stepName} — click + to add the first step inside
                </span>
                <AddBtn parentPath={[...path, 'config', '_steps']} atIndex={0} isTail={true} compact={true}/>
              </div>
            )}
            {(cfg._steps || []).map((child, i) => (
              <React.Fragment key={i}>
                {!readOnly && i === 0 && <AddBtn parentPath={[...path, 'config', '_steps']} atIndex={0} compact={true}/>}
                <LinearStep step={child} depth={depth+1}
                  path={[...path, 'config', '_steps', i]}
                  parentPath={[...path, 'config', '_steps']}
                  indexInParent={i} siblingsLen={cfg._steps.length} ctx={ctx}/>
                {/* Always render — see note in BranchColumn above. */}
                <AddBtn parentPath={[...path, 'config', '_steps']} atIndex={i+1} isTail={i === cfg._steps.length-1} compact={true}/>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}

      {/* Choice — when/otherwise as side-by-side columns. */}
      {isChoice && (
        <div className="linear-container-box" style={{'--accent': accent}}>
          <div className="linear-container-tag">CHOICE</div>
          <div className="linear-branch-row">
            {(cfg.when || []).map((branch, bi) => (
              <BranchColumn key={'w'+bi}
                label={formatBranchHeader('when', branch)}
                branchAccent="#7c3aed"
                steps={branch._steps || []}
                basePath={[...path, 'config', 'when', bi, '_steps']}/>
            ))}
            {cfg.otherwise && (
              <BranchColumn label="Otherwise"
                branchAccent="#6b7280"
                steps={(cfg.otherwise && cfg.otherwise._steps) || []}
                basePath={[...path, 'config', 'otherwise', '_steps']}/>
            )}
          </div>
        </div>
      )}

      {/* DoTry — try body + catches + finally as side-by-side columns. */}
      {isDoTry && (
        <div className="linear-container-box" style={{'--accent': accent}}>
          <div className="linear-container-tag">DO TRY</div>
          <div className="linear-branch-row">
            <BranchColumn label="Try"
              branchAccent="#dc2626"
              steps={cfg._steps || []}
              basePath={[...path, 'config', '_steps']}/>
            {(cfg.doCatch || []).map((c, ci) => (
              <BranchColumn key={'c'+ci}
                label={formatBranchHeader('catch', c)}
                branchAccent="#f59e0b"
                steps={c._steps || []}
                basePath={[...path, 'config', 'doCatch', ci, '_steps']}/>
            ))}
            {cfg.doFinally && (
              <BranchColumn label="Finally"
                branchAccent="#16a34a"
                steps={(cfg.doFinally && cfg.doFinally._steps) || []}
                basePath={[...path, 'config', 'doFinally', '_steps']}/>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── YAML → routeDef parser ────────────────────────────────────────────────
// ── YAML PARSER ──────────────────────────────────────────────────────────
//
// Parses a Camel YAML string into the editor's routeDef model. Inverse of
// generateCamelYaml. Critical correctness properties:
//
//   1. Nested step containers (split.steps, filter.steps, choice.when[].steps,
//      choice.otherwise.steps, doTry.steps, doCatch[].steps, doFinally.steps,
//      multicast.steps, idempotentConsumer.steps) are recursively parsed and
//      stored under cfg._steps / cfg.when[]._steps / etc.
//
//   2. Camel expression blocks are normalised into a single canonical
//      {language, expression} pair regardless of which of the three accepted
//      input shapes was used:
//          { simple: "X" }                              (shorthand)
//          { expression: { simple: "X" } }              (half-canonical)
//          { expression: { simple: { expression: "X" } } } (full-canonical)
//      For setHeader/setProperty we additionally write {type, value} so the
//      legacy form-panel field schema keeps working.
//
//   3. Nested objects/arrays that are NOT step containers and NOT expressions
//      (e.g. to.parameters, marshal.json, setHeaders.headers[], doCatch.exception[])
//      are passed through verbatim. The old parser called JSON.stringify on
//      these and turned them into junk strings � the root cause of every
//      Builder-save data-loss bug.
function parseYamlToRouteDef(yamlText) {
  try {
    const doc = jsyaml.load(yamlText);
    if (!doc) return null;
    const arr = Array.isArray(doc) ? doc : [doc];
    const routeItem = arr.find(item => item && item.route);
    if (!routeItem) return null;
    const route = routeItem.route || {};
    const from = route.from || {};
    const params = {};
    if (from.parameters && typeof from.parameters === 'object') {
      Object.entries(from.parameters).forEach(([k, v]) => { params[k] = stringifyParam(v); });
    }
    const rawSteps = from.steps || route.steps || [];
    return {
      id: route.id || ('route-' + Date.now()),
      description: route.description || '',
      group: route.group || '',
      from: { uri: from.uri || '', params },
      steps: parseStepsArr(rawSteps),
    };
  } catch (e) {
    console.warn('parseYamlToRouteDef failed:', e);
    return null;
  }
}

// Stringify a from-parameter value for the editor (form-panel uses string
// inputs). Booleans/numbers become their literal strings.
function stringifyParam(v) {
  if (v == null) return '';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}

// Detect a Camel expression block, regardless of which of the three accepted
// shapes is used. Returns {language, expression} or null.
function detectExpression(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return null;
  // (a) full / half canonical: { expression: { lang: ... } }
  if (obj.expression && typeof obj.expression === 'object' && !Array.isArray(obj.expression)) {
    const lang = Object.keys(obj.expression).find(k => EXPR_LANGS.includes(k));
    if (lang) {
      const inner = obj.expression[lang];
      const value = (inner && typeof inner === 'object' && !Array.isArray(inner) && 'expression' in inner)
                  ? inner.expression : inner;
      return { language: lang, expression: value == null ? '' : String(value) };
    }
  }
  // (b) shorthand: top-level language key (simple, constant, jq, ...)
  const langKey = Object.keys(obj).find(k => EXPR_LANGS.includes(k));
  if (langKey) {
    const v = obj[langKey];
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      return { language: langKey, expression: String(v) };
    }
    if (v && typeof v === 'object' && !Array.isArray(v) && 'expression' in v) {
      return { language: langKey, expression: String(v.expression == null ? '' : v.expression) };
    }
  }
  return null;
}

function parseStepsArr(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((stepObj, idx) => {
    if (!stepObj || typeof stepObj !== 'object') return null;
    const stepName = Object.keys(stepObj)[0];
    if (!stepName) return null;
    return parseStep(stepName, stepObj[stepName], idx);
  }).filter(Boolean);
}

function parseStep(stepName, raw, idx) {
  const config = parseStepConfig(stepName, raw);
  const meta = (typeof STEP_DISPLAY !== 'undefined' && STEP_DISPLAY[stepName]) || { icon: '⚙️', label: stepName };
  const catalogType = (stepName === 'to' || stepName === 'toD') ? 'component' : 'processor';
  const uniq = idx + '-' + Math.random().toString(36).slice(2, 8);
  return {
    id: 'step-' + uniq,
    stepName,
    title: meta.label || stepName,
    icon: meta.icon || '⚙️',
    color: getNodeColor(stepName, catalogType),
    catalogType,
    config,
  };
}

// Camel YAML DSL: keys that live at the TOP of a `to:` / `toD:` body. Everything
// else (component-specific options like httpMethod, httpUri, connectTimeout) is
// nested under a `parameters:` block. The Builder's form panel reads flat values
// off cfg, so at parse time we hoist parameters.* onto cfg, and at generate time
// we pack the non-DSL keys back into `parameters`. Keeps round-trips lossless
// and the form panel simple.
const TO_DSL_KEYS = new Set([
  'uri', 'description', 'id', 'disabled', 'pattern', 'inheritErrorHandler',
  '__scalar', '__array',
]);
const TOD_DSL_KEYS = new Set([
  ...TO_DSL_KEYS,
  'allowOptimisedComponents', 'cacheSize', 'ignoreInvalidEndpoint',
]);

function parseStepConfig(stepName, raw) {
  if (raw == null) return {};
  if (typeof raw !== 'object') {
    // Shorthand step like `log: "hello"` � store scalar so the generator can re-emit it.
    return { __scalar: typeof raw === 'string' ? raw : String(raw) };
  }
  if (Array.isArray(raw)) {
    return { __array: raw };
  }

  const out = {};

  // ── 1. Extract the expression body (if any) ───────────────────────────────
  // Single canonical model: {language, expression} for ALL expression-bearing
  // steps. The form panel (setHeader/setProperty/setVariable/setBody/transform/
  // split/filter) reads these same two keys, so editor edits and YAML round-trips
  // share one source of truth � no dual-write, no stale-fallback bugs.
  const expr = detectExpression(raw);
  const consumed = new Set();
  if (expr) {
    out.language = expr.language;
    out.expression = expr.expression;
    if (raw.expression !== undefined && typeof raw.expression === 'object') consumed.add('expression');
    if (raw[expr.language] !== undefined) consumed.add(expr.language);
  }

  // ── 2. Walk every other key and recurse where it's a step container ───────
  for (const [k, v] of Object.entries(raw)) {
    if (consumed.has(k)) continue;

    if (k === 'steps' && Array.isArray(v)) {
      out._steps = parseStepsArr(v);
      continue;
    }

    if (stepName === 'choice' && k === 'when' && Array.isArray(v)) {
      out.when = v.map(w => {
        const wExpr = detectExpression(w) || { language: 'simple', expression: '' };
        return {
          language: wExpr.language,
          expression: wExpr.expression,
          _steps: parseStepsArr(w && w.steps),
        };
      });
      continue;
    }

    if (stepName === 'choice' && k === 'otherwise' && v && typeof v === 'object') {
      out.otherwise = { _steps: parseStepsArr(v.steps) };
      continue;
    }

    if (stepName === 'doTry' && k === 'doCatch' && Array.isArray(v)) {
      out.doCatch = v.map(c => ({
        exception: Array.isArray(c && c.exception) ? c.exception
                  : (c && c.exception ? [c.exception] : []),
        _steps: parseStepsArr(c && c.steps),
      }));
      continue;
    }

    if (stepName === 'doTry' && k === 'doFinally' && v && typeof v === 'object') {
      out.doFinally = { _steps: parseStepsArr(v.steps) };
      continue;
    }

    // Pass-through for everything else � INCLUDING nested objects/arrays.
    // This is the key fix: the old parser did JSON.stringify here and
    // destroyed nested structure on every Builder save.
    out[k] = v;
  }

  // ── Special handling for `to:` / `toD:` parameters block ──────────────────
  // Hoist `parameters.*` onto cfg so the form panel can read flat field names
  // (e.g. cfg.httpMethod). The generator inverts this and re-emits a clean
  // `parameters:` block. Existing top-level keys win over the parameters
  // version so a hand-authored override (e.g. `to: { uri: x, httpMethod: POST }`
  // mixed with `parameters: { httpMethod: GET }`) does the sensible thing.
  if ((stepName === 'to' || stepName === 'toD')
      && out.parameters && typeof out.parameters === 'object' && !Array.isArray(out.parameters)) {
    for (const [pk, pv] of Object.entries(out.parameters)) {
      if (out[pk] === undefined) out[pk] = pv;
    }
    delete out.parameters;
  }

  return out;
}


// ── ROUND-TRIP SELF-TEST ─────────────────────────────────────────────────
//
// Runs parseYamlToRouteDef → generateCamelYaml → parseYamlToRouteDef on the
// supplied YAML and compares the two routeDefs structurally. Mismatches are
// the smoking gun for serializer regressions. Logs a console.warn with a
// detailed diff path on failure; returns true if the round-trip is clean.
//
// Exposed on window.__camelRoundTrip for ad-hoc testing from the browser
// console: window.__camelRoundTrip(yaml).
function camelYamlRoundTripCheck(yaml, label) {
  if (!yaml || typeof yaml !== 'string') return true;
  try {
    const a = parseYamlToRouteDef(yaml);
    if (!a) { console.warn('[round-trip:'+(label||'?')+'] initial parse returned null'); return false; }
    const dumped = generateCamelYaml(a);
    const b = parseYamlToRouteDef(dumped);
    if (!b) { console.warn('[round-trip:'+(label||'?')+'] re-parse of generated YAML returned null', dumped); return false; }
    const diff = _routeDefDiff(a, b, 'routeDef');
    if (diff) {
      console.warn('[round-trip:'+(label||'?')+'] data loss detected at '+diff.path+':',
        '\n  before:', diff.before,
        '\n  after :', diff.after,
        '\n  yaml-in :', yaml,
        '\n  yaml-out:', dumped);
      return false;
    }
    return true;
  } catch (e) {
    console.warn('[round-trip:'+(label||'?')+'] threw:', e);
    return false;
  }
}

// Recursive structural diff. Returns the first difference as {path,before,after}
// or null if equal. Only structural identity matters � id/icon/color fields are
// regenerated on every parse (they include random suffixes and emoji glyphs)
// so we skip them.
function _routeDefDiff(a, b, path) {
  const SKIP = new Set(['id','icon','color','title']);
  if (a === b) return null;
  if (a == null || b == null) return { path, before: a, after: b };
  if (typeof a !== typeof b) return { path, before: a, after: b };
  if (Array.isArray(a) !== Array.isArray(b)) return { path, before: a, after: b };
  if (Array.isArray(a)) {
    if (a.length !== b.length) return { path: path+'.length', before: a.length, after: b.length };
    for (let i = 0; i < a.length; i++) {
      const d = _routeDefDiff(a[i], b[i], path+'['+i+']');
      if (d) return d;
    }
    return null;
  }
  if (typeof a === 'object') {
    const ak = Object.keys(a).filter(k => !SKIP.has(k)).sort();
    const bk = Object.keys(b).filter(k => !SKIP.has(k)).sort();
    if (ak.length !== bk.length || ak.some((k,i)=>k!==bk[i])) {
      return { path: path+' (keys)', before: ak, after: bk };
    }
    for (const k of ak) {
      const d = _routeDefDiff(a[k], b[k], path+'.'+k);
      if (d) return d;
    }
    return null;
  }
  return a === b ? null : { path, before: a, after: b };
}

// Expose for browser-console debugging.
if (typeof window !== 'undefined') {
  window.__camelRoundTrip = (yaml) => camelYamlRoundTripCheck(yaml, 'manual');
}

// ── NEW ROUTE BUILDER MODAL (for IntegrationsPage) ───────────────────────
// ── Embedded flow — view-only mirror of the canvas inside the test pane ─
// Lets users trigger, watch step status, and drill into raw data without
// looking at the left canvas at all. Reuses the same recursive LinearStep
// component as the canvas with readOnly=true so the move/delete/add buttons
// don't render and clicking the card body is a no-op (only the 👁 eye icon
// is interactive). Status comes from the same stepStatuses map that drives
// the canvas, so the panel mirror lights up in lockstep with the canvas.
function EmbeddedFlow({routeDef, stepStatuses, onSelectStep, highlightedStepIdx, capturedSteps}) {
  // A Java DSL integration has no camelRoute, so routeDef never populates and
  // the structural flow below has nothing to walk. The run itself is not blind
  // though: DebugInterceptStrategy captures steps off the live exchange, so by
  // the time a run is under way we know exactly what executed. Render that
  // instead — what actually ran, rather than what was drawn.
  const structural = routeDef && (routeDef.steps || []).length;
  if (!structural) {
    const caps = capturedSteps || [];
    if (!caps.length) return null;
    return (
      <div style={{display:'flex',flexDirection:'column',gap:0}}>
        {caps.map((s, i) => {
          const status = (s && s.status) || (stepStatuses || {})[i] || '';
          const failed = String(status).toUpperCase() === 'FAILED';
          const active = highlightedStepIdx === i;
          return (
            <div key={i}>
              {i > 0 && <div className="linear-rail" aria-hidden="true"><span/></div>}
              <div role="button" tabIndex={0}
                onClick={()=>onSelectStep && onSelectStep(i)}
                onKeyDown={e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); onSelectStep && onSelectStep(i); } }}
                title="Open this step's input and output"
                style={{display:'flex',alignItems:'center',gap:10,padding:'8px 10px',cursor:'pointer',
                  border:'1px solid '+(active?'var(--brand-start)':'var(--border)'),
                  background: active?'var(--surface2)':'var(--surface)',
                  borderRadius:8,fontSize:12.5}}>
                <span style={{width:20,textAlign:'center',color: failed?'var(--error)':'var(--text3)'}}>
                  {failed ? '✗' : status ? '✓' : '•'}
                </span>
                <span style={{flex:1,minWidth:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {(s && (s.name || s.stepName)) || `Step ${i + 1}`}
                </span>
                {s && s.durationMs != null && (
                  <span style={{color:'var(--text3)',fontFamily:'ui-monospace,monospace',fontSize:11}}>{s.durationMs}ms</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  const flatIndex = walkRouteSteps(routeDef.steps, 0, ['steps']);
  const pathToIndex = new Map();
  flatIndex.forEach((e, i) => pathToIndex.set(e.path.join('/'), i));
  // LinearStep's openInspector callback fires with the step's `path` array
  // (e.g. ['steps', 2]). selectedStepIdx upstream expects a numeric
  // structural index into the captured-steps array, so we translate the
  // path here. Without this wrap, setSelectedStepIdx ends up holding the
  // path array, and StepInspector renders "Loading step steps,21…" because
  // it's stringifying the array as the step number.
  // Click-to-inspect: in the read-only panel mirror, both the card body
  // AND the 👁 eye icon should open the inspector. Without this, users
  // see the badge ✓/✗ on a card and instinctively click it — and nothing
  // happens, because openConfig is a no-op stub. Postman/Workato pattern:
  // the whole row is the click target.
  const openInspectorByPath = (path) => {
    const idx = pathToIndex.get(path.join('/'));
    if (idx != null) onSelectStep(idx);
  };
  // Connector rail between cards — the canvas does this via the readOnly
  // branch of its own AddBtn, but the panel previously stubbed AddBtn to
  // null and lost the visual flow. With this in place, adjacent cards
  // are joined by a thin vertical line (Karavan / Workato pattern) so
  // the embedded mirror reads as a graph rather than a stack of boxes.
  // isTail=true means "this rail would dangle below the last sibling" —
  // we render nothing there to keep the flow clean.
  const RailBtn = ({compact, isTail}) => {
    if (isTail) return null;
    return <div className={`linear-rail${compact ? ' compact' : ''}`} aria-hidden="true"><span/></div>;
  };
  const ctx = {
    configStep: null,
    openConfig: openInspectorByPath,   // card body click → inspector (panel is view-only,
                                       //   so there's no config to open anyway)
    openInspector: openInspectorByPath, // 👁 eye → same target
    moveStepAtPath: () => {},      // stubs — readOnly hides the buttons anyway
    deleteStepAtPath: () => {},
    readOnly: true,
    stepStatuses: stepStatuses || {},
    pathToIndex,
    highlightedStepIdx: highlightedStepIdx == null ? null : highlightedStepIdx,
    AddBtn: RailBtn,
  };
  const tops = routeDef.steps;
  return (
    <div className="embedded-flow linear-tree-root in-panel">
      {tops.map((step, i) => (
        <React.Fragment key={i}>
          <LinearStep step={step} depth={0}
            path={['steps', i]} parentPath={['steps']}
            indexInParent={i} siblingsLen={tops.length} ctx={ctx}/>
          {/* Top-level rail between siblings — drops the trailing rail
              after the last card so the flow doesn't dangle. */}
          {i < tops.length - 1 && <RailBtn/>}
        </React.Fragment>
      ))}
    </div>
  );
}

// ── Test-run side panel ──────────────────────────────────────────────────
// Karavan / Postman / Workato-style live test surface. Replaces the old
// blocking TestRunModal: opens alongside the canvas, streams step events
// over SSE, lets the user click any step on the canvas to inspect its
// input/output without leaving the editor.
//
// The trigger-aware input form switches on `routeDef.from.uri` scheme:
//   timer:/quartz:  → just a "Trigger Now" button (no payload accepted)
//   everything else → v2 fallback: optional JSON textarea payload
function TestRunPanel({
  routeDef, integration, runStatus, runError, capturedSteps,
  selectedStepIdx, stepStatuses, testRunId,
  onTriggerRun, onCancelRun, onSelectStep, onClose
}) {
  // Trigger identity has two sources and only one of them exists for a Java DSL
  // integration. routeDef is parsed from camelRoute, which a Java route does not
  // have — so `from.uri` is empty and the panel used to render "unknown" and a
  // payload box for every Java route regardless of how it is actually triggered.
  // integration.triggerType is set on every integration, so it is the fallback.
  const fromUri = (routeDef && routeDef.from && routeDef.from.uri) || '';
  const uriScheme = fromUri.split(':')[0].toLowerCase();
  const triggerType = (integration && integration.triggerType) || '';
  const SCHEDULED_TYPES = ['SCHEDULED', 'DB_POLL'];
  const scheme = uriScheme || (triggerType ? triggerType.toLowerCase().replace(/_/g, '-') : '');
  const isScheduled = uriScheme
    ? (uriScheme === 'timer' || uriScheme === 'quartz')
    : SCHEDULED_TYPES.includes(triggerType);
  const isRunning = runStatus === 'RUNNING';
  const [payload, setPayload] = useState('');
  // When the user clicks a step on the canvas we lazy-load the full body
  // (the SSE stream only carried a 240-char preview, to keep events small).
  const [fullStepData, setFullStepData] = useState(null);
  const [stepLoadError, setStepLoadError] = useState('');

  useEffect(() => {
    setFullStepData(null);
    setStepLoadError('');
    if (selectedStepIdx == null || !(integration||{}).id) return;
    const preview = capturedSteps[selectedStepIdx];
    // Step has no captured data yet — common when the user clicks the eye
    // on a card that never ran (route failed earlier, or split iteration
    // didn't reach this card). Render an explicit "not reached" state
    // instead of leaving the spinner stuck forever.
    if (!preview) {
      setFullStepData({
        __notReached: true,
        name: 'Step not reached',
        status: 'PENDING',
        input: null, output: null, error: null, metadata: {}
      });
      return;
    }
    // Lazy-fetch the full body via the new GET /steps/{idx} endpoint, using
    // the run-level testRunId held by the parent (passed in via props).
    if (testRunId) {
      API('GET', `/api/integrations/${integration.id}/test-runs/${testRunId}/steps/${selectedStepIdx}`)
        .then(setFullStepData)
        .catch(e => {
          // Network or run-evicted — fall back to the SSE-cached preview so
          // the user still sees the 240-char snippets rather than an error.
          setFullStepData({
            name: preview.name, type: preview.type, status: preview.status,
            startedAt: preview.startedAt, durationMs: preview.durationMs,
            input: preview.inputPreview, output: preview.outputPreview,
            error: preview.error, metadata: preview.metadata || {}
          });
        });
    } else {
      // No active run — show whatever the SSE event held.
      setFullStepData({
        name: preview.name, type: preview.type, status: preview.status,
        startedAt: preview.startedAt, durationMs: preview.durationMs,
        input: preview.inputPreview, output: preview.outputPreview,
        error: preview.error, metadata: preview.metadata || {}
      });
    }
  }, [selectedStepIdx, (integration||{}).id, capturedSteps, testRunId]);

  const statusPill = (() => {
    const map = {
      IDLE:     { bg:'rgba(148,163,184,.15)', col:'#475569', txt:'Idle'    },
      RUNNING:  { bg:'rgba(99,102,241,.18)',  col:'#4338ca', txt:'Running' },
      SUCCESS:  { bg:'rgba(22,163,74,.15)',   col:'#15803d', txt:'Success' },
      FAILED:   { bg:'rgba(239,68,68,.15)',   col:'#b91c1c', txt:'Failed'  },
      CANCELED: { bg:'rgba(148,163,184,.18)', col:'#475569', txt:'Canceled'}
    };
    const m = map[runStatus] || map.IDLE;
    return (
      <span style={{padding:'3px 10px',borderRadius:10,fontSize:10.5,fontWeight:700,
        textTransform:'uppercase',letterSpacing:'.5px',background:m.bg,color:m.col}}>
        {runStatus === 'RUNNING' && <span style={{display:'inline-block',width:7,height:7,borderRadius:'50%',background:m.col,marginRight:6,animation:'tlPulse 1.2s infinite'}}/>}
        {m.txt}
      </span>
    );
  })();

  // When the test pane is open, the canvas hides (display:none in parent
  // layout) and this panel takes the full modal width. When a step is
  // ALSO selected for inspection, the panel splits left/right: flow on
  // the left, inspector on the right — same pattern Postman/Workato use,
  // so the user keeps the visual context of the run while drilling in.
  const splitForInspector = selectedStepIdx != null;
  return (
    <div className="test-run-panel" style={{
      flex:1,minWidth:0,maxWidth: splitForInspector ? 'none' : 1100,
      marginLeft:'auto',marginRight:'auto',
      borderLeft:'1px solid var(--border)',borderRight:'1px solid var(--border)',
      background:'var(--surface)',display:'flex',flexDirection:'column',
      height:'100%',minHeight:0,overflow:'hidden'
    }}>
      {/* Header */}
      <div style={{padding:'14px 18px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,
          background:'linear-gradient(135deg, rgba(99,102,241,.08), rgba(139,92,246,.02))'}}>
        <span style={{fontSize:20,color:'#6366f1'}}><BuilderTestIcon size={20}/></span>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:800,fontSize:13,color:'var(--text)'}}>Test Run</div>
          <div style={{fontSize:10.5,color:'var(--text3)',marginTop:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
            {integration ? integration.name : '(unsaved integration)'}
          </div>
        </div>
        {statusPill}
        <button onClick={onClose} title="Close test panel"
          style={{background:'none',border:'none',color:'var(--text3)',cursor:'pointer',fontSize:16,padding:4,display:'inline-flex'}}><CloseIcon size={15}/></button>




      </div>

      {/* Tabs — Input/Run | Step Inspector (when a step is selected) */}
      {/* Body — splits horizontally when a step is selected for inspection
          so the flow stays visible on the left while the inspector lives
          on the right. Postman / Workato pattern: never lose context of
          the run while drilling into a step. */}
      <div style={{flex:1,display:'flex',flexDirection: splitForInspector ? 'row' : 'column',minHeight:0,overflow:'hidden'}}>
        {/* Left column (or full width when no step selected) — Trigger
            controls + embedded flow. Always rendered so users can pick a
            different step or re-trigger without losing the inspector. */}
        <div style={{flex: splitForInspector ? '0 0 460px' : '1 1 auto',
                     overflow:'auto',padding:'14px 16px',display:'flex',flexDirection:'column',gap:12,minHeight:0,
                     borderRight: splitForInspector ? '1px solid var(--border)' : 'none'}}>
          {/* Compact trigger line — kept tight because the embedded flow
              below carries the visual weight now. */}
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'.6px',color:'var(--text3)'}}>Trigger</span>
            <span style={{fontSize:11,fontWeight:700,color:'#6366f1',fontFamily:'ui-monospace,monospace'}}>
              {scheme || 'unknown'}
            </span>
          </div>

          {/* Webhook / file / kafka fallback payload — only when the trigger
              is NOT scheduled (timer/quartz routes ignore body). */}
          {!isScheduled && (
            <textarea value={payload} onChange={e=>setPayload(e.target.value)}
              placeholder='{ "key": "value" }   ← optional JSON payload (v2 forms coming)'
              style={{width:'100%',minHeight:80,padding:10,borderRadius:8,border:'1px solid var(--border)',
                background:'var(--surface2)',color:'var(--text)',fontFamily:'ui-monospace,monospace',
                fontSize:12,resize:'vertical',outline:'none',boxSizing:'border-box'}}/>
          )}

          {/* Run controls */}
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            {isRunning ? (
              <button onClick={onCancelRun}
                style={{flex:1,padding:'10px 16px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,fontWeight:700,
                  background:'rgba(239,68,68,.12)',color:'#dc2626',display:'inline-flex',alignItems:'center',justifyContent:'center',gap:6}}>
                <StepIconSvg name="stop" size={13}/> Cancel Run
              </button>
            ) : (
              <button onClick={()=>onTriggerRun(isScheduled ? '' : payload)}
                disabled={!integration || !integration.id}
                style={{flex:1,padding:'10px 16px',borderRadius:8,border:'none',cursor:(integration||{}).id?'pointer':'not-allowed',fontSize:13,fontWeight:700,
                  background: (integration||{}).id ? 'var(--brand-grad)' : 'var(--surface3)',
                  color: (integration||{}).id ? '#fff' : 'var(--text3)',
                  boxShadow:(integration||{}).id?'0 2px 8px rgba(99,102,241,.25)':'none',
                  opacity: (integration||{}).id ? 1 : 0.6,display:'inline-flex',alignItems:'center',justifyContent:'center',gap:6}}>
                <StepIconSvg name="from" size={13}/> Trigger Now
              </button>
            )}
          </div>

          {runError && (
            <div style={{padding:'10px 12px',borderRadius:8,background:'rgba(239,68,68,.08)',border:'1px solid rgba(239,68,68,.3)',color:'#b91c1c',fontSize:12,fontFamily:'ui-monospace,monospace',whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
              {runError}
            </div>
          )}

          {/* Embedded flow — view-only mirror of the canvas. Each card has
              the 👁 eye icon and ✓/✗ status badge. Clicking the eye
              opens the StepInspector to the right (split view) instead
              of replacing this view. */}
          <div style={{marginTop:4,paddingTop:10,borderTop:'1px dashed var(--border)'}}>
            <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'.6px',color:'var(--text3)',marginBottom:8,display:'flex',alignItems:'center',gap:6}}>
              Flow
              {capturedSteps.filter(Boolean).length > 0 && (
                <span style={{padding:'1px 7px',borderRadius:7,background:'rgba(22,163,74,.12)',color:'#15803d',fontSize:9.5,fontWeight:700}}>
                  {capturedSteps.filter(Boolean).length} captured
                </span>
              )}
            </div>
            <EmbeddedFlow
              routeDef={routeDef}
              stepStatuses={stepStatuses}
              onSelectStep={onSelectStep}
              highlightedStepIdx={selectedStepIdx}
              capturedSteps={capturedSteps}/>
          </div>
        </div>

        {/* Right column — Step Inspector (only when a step is selected) */}
        {splitForInspector && (
          <div style={{flex:'1 1 auto',overflow:'auto',padding:'14px 18px',minWidth:0,minHeight:0}}>
            <StepInspector
              stepData={fullStepData}
              stepIndex={selectedStepIdx}
              loadError={stepLoadError}
              onBack={()=>onSelectStep(null)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// ── Step Inspector — input / output / headers / properties / error tabs ──
//
// stepData.input/output may be either:
//   (a) a structured JSON snapshot string emitted by DebugInterceptStrategy:
//       {"__snapshot": true, "body": "...", "headers": {...}, "properties": {...}}
//   (b) a plain string (older runs / Camel emitting raw body before the
//       snapshot upgrade landed) — fallback to body-only display.
//
// We parse upfront so the body/headers/properties accordion can render
// without re-parsing on every tab switch.
function parseSnapshot(raw) {
  if (raw == null || raw === '') return { body: null, headers: {}, properties: {} };
  if (typeof raw !== 'string') return { body: String(raw), headers: {}, properties: {} };
  // Quick reject: if the string doesn't start with `{` it can't be JSON.
  // Saves Jackson-style parse failures on noisy ${exchangeProperty.X} sources.
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return { body: raw, headers: {}, properties: {} };
  try {
    const obj = JSON.parse(trimmed);
    if (obj && obj.__snapshot === true) {
      return {
        body: obj.body == null ? null : (typeof obj.body === 'string' ? obj.body : JSON.stringify(obj.body, null, 2)),
        headers: obj.headers || {},
        properties: obj.properties || {},
        warning: obj.__warning || null
      };
    }
    // It parsed but isn't a snapshot — render as JSON body.
    return { body: JSON.stringify(obj, null, 2), headers: {}, properties: {} };
  } catch (e) {
    // Not JSON — plain text body.
    return { body: raw, headers: {}, properties: {} };
  }
}

function StepInspector({stepData, stepIndex, loadError, onBack}) {
  const [tab, setTab] = useState('output');

  if (loadError) {
    return (
      <div>
        <button onClick={onBack} style={{background:'none',border:'none',color:'#6366f1',cursor:'pointer',fontSize:12,fontWeight:600,padding:'4px 0'}}>← Back</button>
        <div style={{padding:12,borderRadius:8,background:'rgba(239,68,68,.08)',color:'#b91c1c',fontSize:12}}>
          Could not load step: {loadError}
        </div>
      </div>
    );
  }
  if (!stepData) {
    // stepIndex can be null/undefined briefly between selection clicks;
    // also harden against accidental non-numeric values so we never render
    // "Loading step steps,21…" gibberish again.
    const label = (typeof stepIndex === 'number') ? `step ${stepIndex+1}` : 'step';
    return <div style={{padding:14,color:'var(--text3)',fontSize:12}}>Loading {label}…</div>;
  }
  // Step the user clicked on never executed during this run (route failed
  // earlier, or this is a nested split-iteration step that never fired).
  if (stepData.__notReached) {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:'#6366f1',cursor:'pointer',fontSize:12,fontWeight:600,padding:'4px 0',alignSelf:'flex-start'}}>← Back</button>
        <div style={{padding:14,borderRadius:10,background:'rgba(148,163,184,.10)',border:'1px dashed rgba(148,163,184,.4)',color:'var(--text2)',fontSize:12.5,lineHeight:1.55,display:'flex',alignItems:'flex-start',gap:8}}>
          <span style={{display:'inline-flex'}}><StepIconSvg name="stop" size={16}/></span>
          <div>
            <div style={{fontWeight:700,color:'var(--text)',marginBottom:3}}>
              {(typeof stepIndex === 'number') ? `Step ${stepIndex+1} ` : 'This step '}was not reached
            </div>
            The flow stopped before this step executed — most likely an
            earlier step failed (check for cards marked ✗ above), or this
            sits inside a branch that didn't run (e.g. a Choice's
            non-matching <code>when</code>, or split body was empty).
          </div>
        </div>
      </div>
    );
  }

  const status = stepData.status || 'PENDING';
  const statusColor = status === 'SUCCESS' ? '#15803d' : status === 'FAILED' ? '#b91c1c' : '#475569';
  const inSnap = parseSnapshot(stepData.input);
  const outSnap = parseSnapshot(stepData.output);
  const tabs = ['input','output','metadata'].concat(stepData.error ? ['error'] : []);

  return (
    <div style={{display:'flex',flexDirection:'column',gap:10,minHeight:0,flex:1}}>
      <button onClick={onBack} style={{background:'none',border:'none',color:'#6366f1',cursor:'pointer',fontSize:12,fontWeight:600,padding:'4px 0',textAlign:'left',alignSelf:'flex-start'}}>← Back to run</button>
      <div style={{padding:'8px 12px',borderRadius:8,background:'var(--surface2)',border:'1px solid var(--border)'}}>
        <div style={{fontSize:11,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',letterSpacing:'.5px',marginBottom:2}}>
          Step {stepIndex+1} · <span style={{color:statusColor}}>{status}</span>
        </div>
        <div style={{fontSize:13,fontWeight:700,color:'var(--text)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{stepData.name}</div>
        <div style={{fontSize:10.5,color:'var(--text3)',marginTop:3,display:'flex',gap:14}}>
          <span><strong>Type:</strong> {stepData.type}</span>
          {stepData.durationMs != null && <span><strong>Duration:</strong> {stepData.durationMs}ms</span>}
        </div>
      </div>

      <div style={{display:'flex',gap:4,borderBottom:'1px solid var(--border)'}}>
        {tabs.map(t => (
          <button key={t} onClick={()=>setTab(t)}
            style={{padding:'6px 12px',border:'none',background:'none',cursor:'pointer',
              color: tab===t ? '#6366f1' : 'var(--text3)',
              fontWeight: tab===t ? 700 : 500,fontSize:12,textTransform:'capitalize',
              borderBottom: tab===t ? '2px solid #6366f1' : '2px solid transparent',
              marginBottom:-1}}>
            {t}
          </button>
        ))}
      </div>

      <div style={{flex:1,overflow:'auto',minHeight:0}}>
        {tab === 'input'  && <MessageSnapshot snap={inSnap}  emptyPlaceholder="(no input captured)" />}
        {tab === 'output' && <MessageSnapshot snap={outSnap} emptyPlaceholder="(no output captured)" />}
        {tab === 'metadata' && (
          stepData.metadata && Object.keys(stepData.metadata).length > 0 ? (
            <table style={{width:'100%',fontSize:11.5,fontFamily:'ui-monospace,monospace',borderCollapse:'collapse'}}>
              <tbody>
                {Object.entries(stepData.metadata).map(([k,v]) => (
                  <tr key={k} style={{borderBottom:'1px solid var(--border)'}}>
                    <td style={{padding:'4px 8px',color:'var(--text3)',width:'40%',verticalAlign:'top'}}>{k}</td>
                    <td style={{padding:'4px 8px',color:'var(--text)',wordBreak:'break-all'}}>{String(v)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <div style={{padding:10,color:'var(--text3)',fontSize:12}}>(no metadata)</div>
        )}
        {tab === 'error' && (
          <div style={{padding:'10px 12px',borderRadius:8,background:'rgba(239,68,68,.08)',border:'1px solid rgba(239,68,68,.3)',color:'#b91c1c',fontSize:11.5,fontFamily:'ui-monospace,monospace',whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
            {stepData.error}
          </div>
        )}
      </div>
    </div>
  );
}

// Renders one direction of a message snapshot — body + headers + properties
// as three collapsible sections. Mirrors Postman / Workato test-run UIs
// where the user can drill into the exact wire-level payload that flowed
// through the step.
function MessageSnapshot({snap, emptyPlaceholder}) {
  const headerCount = snap.headers ? Object.keys(snap.headers).length : 0;
  const propCount   = snap.properties ? Object.keys(snap.properties).length : 0;
  const hasAnything = (snap.body != null && snap.body !== '') || headerCount > 0 || propCount > 0;
  if (!hasAnything) {
    return <div style={{padding:10,color:'var(--text3)',fontSize:12,fontStyle:'italic'}}>{emptyPlaceholder}</div>;
  }
  return (
    <div style={{display:'flex',flexDirection:'column',gap:10}}>
      {snap.warning && (
        <div style={{padding:'6px 10px',borderRadius:6,background:'rgba(245,158,11,.10)',border:'1px solid rgba(245,158,11,.3)',color:'#b45309',fontSize:11,display:'flex',alignItems:'flex-start',gap:6}}>
          <WarningIcon size={11}/> {snap.warning}
        </div>
      )}
      <SnapshotSection title="Body" defaultOpen={true}>
        <CodeBlock text={snap.body} placeholder="(empty body)"/>
      </SnapshotSection>
      <SnapshotSection title={`Headers (${headerCount})`} defaultOpen={true}>
        <KeyValueTable map={snap.headers} emptyLabel="(no headers)"/>
      </SnapshotSection>
      <SnapshotSection title={`Exchange properties (${propCount})`} defaultOpen={false}>
        <KeyValueTable map={snap.properties} emptyLabel="(no properties)"/>
      </SnapshotSection>
    </div>
  );
}

function SnapshotSection({title, defaultOpen, children}) {
  const [open, setOpen] = useState(defaultOpen !== false);
  return (
    <div style={{border:'1px solid var(--border)',borderRadius:8,overflow:'hidden'}}>
      <button onClick={()=>setOpen(o=>!o)}
        style={{width:'100%',padding:'7px 12px',background:'var(--surface2)',border:'none',cursor:'pointer',
                display:'flex',alignItems:'center',gap:8,fontSize:11.5,fontWeight:700,color:'var(--text)',
                textTransform:'uppercase',letterSpacing:'.4px',textAlign:'left'}}>
        <span style={{fontSize:10,color:'var(--text3)',transform: open ? 'rotate(90deg)' : 'none',transition:'transform .15s'}}>▶</span>
        {title}
      </button>
      {open && <div style={{padding:8}}>{children}</div>}
    </div>
  );
}

function KeyValueTable({map, emptyLabel}) {
  const entries = map ? Object.entries(map) : [];
  if (entries.length === 0) {
    return <div style={{padding:8,color:'var(--text3)',fontSize:11.5,fontStyle:'italic'}}>{emptyLabel}</div>;
  }
  return (
    <table style={{width:'100%',fontSize:11.5,fontFamily:'ui-monospace,Consolas,monospace',borderCollapse:'collapse'}}>
      <tbody>
        {entries.map(([k,v]) => (
          <tr key={k} style={{borderBottom:'1px solid var(--border)'}}>
            <td style={{padding:'4px 8px',color:'var(--text3)',width:'42%',verticalAlign:'top',fontWeight:600,wordBreak:'break-all'}}>{k}</td>
            <td style={{padding:'4px 8px',color:'var(--text)',wordBreak:'break-all',whiteSpace:'pre-wrap'}}>{v == null ? <em style={{color:'var(--text3)'}}>null</em> : String(v)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// Pretty-printed code block — auto-detects JSON and beautifies. Always
// scrollable inside its own 360px-tall box so a 100kB payload doesn't push
// the whole inspector to a mile of scroll height.
//
// We try three parses in order, because bodies arrive in three flavors:
//   1. Real JSON          {"a":1, "b":[...]}             → JSON.parse, pretty-print
//   2. JSON with whitespace / leading metadata           → strip wrapper if present
//   3. Java Map.toString() {a=1, b=[...]}               → convert to JSON-ish, parse, pretty-print
// (Flavour 3 was the bug case after an `unmarshal` step — see the
// backend snapshot extractor, which now emits real JSON. We keep the
// frontend converter as a safety net for older runs already in SQLite.)
function CodeBlock({text, placeholder}) {
  if (text == null || text === '') {
    return <div style={{padding:10,color:'var(--text3)',fontSize:12,fontStyle:'italic'}}>{placeholder || '(empty)'}</div>;
  }
  let display = text;
  let beautified = false;
  const t = String(text).trim();
  // (1) Already JSON — fastest path.
  try {
    if ((t.startsWith('{') || t.startsWith('[')) && (t.endsWith('}') || t.endsWith(']'))) {
      display = JSON.stringify(JSON.parse(t), null, 2);
      beautified = true;
    }
  } catch (e) { /* fall through */ }
  // (3) Java Map.toString() style — `{key=value, key2=value2}` or nested
  // `{a={b=c}}` — convert key= → "key": and value tokens to quoted strings
  // where appropriate, then JSON.parse. Best-effort, no-op on failure.
  if (!beautified && (t.startsWith('{') && t.includes('=') && !t.includes('":'))) {
    try {
      // Naive but effective for the common Camel-after-unmarshal case:
      //   - bare-word keys followed by `=`  → "key":
      //   - bare-word values (no commas/spaces/braces) → "value"
      //   - already-numeric values left bare
      let jsonish = t
        .replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_-]*)\s*=/g, '$1"$2":')
        .replace(/:\s*([^",{}\[\]\s][^,{}\[\]]*?)(?=[,}])/g, (_m, v) => {
          const trimmed = v.trim();
          if (/^-?\d+(\.\d+)?$/.test(trimmed)) return ': ' + trimmed;
          if (trimmed === 'true' || trimmed === 'false' || trimmed === 'null') return ': ' + trimmed;
          return ': "' + trimmed.replace(/"/g, '\\"') + '"';
        });
      display = JSON.stringify(JSON.parse(jsonish), null, 2);
      beautified = true;
    } catch (e) { /* not Map-shaped or too ambiguous to convert; show raw */ }
  }
  return (
    <pre style={{margin:0,padding:10,borderRadius:8,background:'#1e1e2e',color:'#a5f3fc',
        fontSize:11.5,fontFamily:'ui-monospace,Consolas,monospace',lineHeight:1.45,
        whiteSpace:'pre',wordBreak:'normal',
        maxHeight:360,overflow:'auto'}}>
      {display}
    </pre>
  );
}

function NewRouteBuilderModal({initial, onClose, onSaved, showToast, projects=[]}) {
  const readOnly = !!(initial && initial.status === 'ACTIVE');
  const [name, setName] = useState((initial && initial.name) || '');
  const [description, setDescription] = useState((initial && initial.description) || '');
  const [category, setCategory] = useState((initial && initial.category) || '');
  const [projectId, setProjectId] = useState((initial && initial.projectId) || '');
  // Maximize toggle — when true the modal goes full-viewport (minus 8px
  // breathing room) for big-screen workflows. Persisted to localStorage
  // so power users who always max it don't have to re-toggle every open.
  const [maximized, setMaximized] = useState(() => {
    try { return localStorage.getItem('builder.modalMaximized') === '1'; }
    catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem('builder.modalMaximized', maximized ? '1' : '0'); } catch {}
  }, [maximized]);
  const [routeDef, setRouteDef] = useState(() => {
    if (initial && initial.flowDefinition) {
      try { return JSON.parse(initial.flowDefinition); } catch(e) {}
    }
    if (initial && initial.camelRoute) {
      const parsed = parseYamlToRouteDef(initial.camelRoute);
      // Run the round-trip self-test on load so any data loss caused by the
      // serializer is surfaced immediately in the console � not silently
      // discovered three weeks later when the user complains the route stopped
      // deploying.
      camelYamlRoundTripCheck(initial.camelRoute, 'modal-open:'+(initial.id||initial.name||'?'));
      if (parsed) return parsed;
    }
    return { id: 'route-' + Date.now(), description: '', from: { uri: '', params: {} }, steps: [] };
  });
  // ── Authoring mode and view ───────────────────────────────────────────────
  // An integration is authored one of two ways, and the mode is a property of
  // the record, not of this component: Java DSL (javaRouteSource, edited in
  // Monaco) or Camel YAML (camelRoute, designed in Kaoto). The mode picks which
  // views exist:
  //
  //   java    -> 'java'              one view, the Monaco editor
  //   yaml    -> 'design' | 'code'   Kaoto, or the raw YAML behind it
  //
  // `yamlText` is the single source of truth in YAML mode. `routeDef` is derived
  // from it for TestRunPanel's step flow and is never serialised back — the
  // home-grown generateCamelYaml is deliberately out of the write path, since
  // round-tripping through it is what lost `constant:` shorthands, nested
  // `description:` into `parameters:` and truncated block scalars.
  const [activeView, setActiveView] = useState(() => (initial && initial.builderClassName) ? 'java' : 'design');
  const [yamlText, setYamlText] = useState(() => {
    if (initial && initial.camelRoute) return initial.camelRoute;
    return '';
  });
  const [yamlError, setYamlError] = useState('');
  const [saving, setSaving] = useState(false);
  const [validating, setValidating] = useState(false);
  const [validation, setValidation] = useState(null); // { valid, error, errorType, routeIds, message }

  // ── Java DSL mode ──────────────────────────────────────────────────────────
  const hasJava = !!(initial && initial.builderClassName);
  const [javaSource, setJavaSource] = useState(() => (initial && initial.javaRouteSource) || '');
  const [javaLoading, setJavaLoading] = useState(false);

  // Monaco Editor instance for the Java source view
  const monacoContainerRef = useRef(null);
  const monacoEditorRef = useRef(null);
  const monacoLastValueRef = useRef(null);
  const pendingSourceRef = useRef(null);

  // Fetch Java source from the API when opening a Java DSL integration
  useEffect(() => {
    if (!hasJava || !initial || !initial.id) return;
    let cancelled = false;
    setJavaLoading(true);
    // authHeaders() comes from index.html's inline script — the babel scripts
    // share one global scope. /api/integrations is authenticated now, so this
    // raw fetch needs the token too.
    authHeaders()
      .then(h => fetch('/api/integrations/source/' + initial.id, { headers: h }))
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!cancelled && data && data.source) {
          pendingSourceRef.current = data.source;
          setJavaSource(data.source);
          // If Monaco is already mounted, push the source directly into the
          // editor.  We only do this when the editor's current value differs
          // from the fetched source — if the user has already typed, their
          // edits take precedence (monacoLastValueRef tracks the editor state).
          if (monacoEditorRef.current && monacoLastValueRef.current !== data.source) {
            const pos = monacoEditorRef.current.getPosition();
            monacoEditorRef.current.setValue(data.source);
            if (pos) monacoEditorRef.current.setPosition(pos);
            monacoLastValueRef.current = data.source;
          }
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setJavaLoading(false); });
    return () => { cancelled = true; };
  }, [hasJava, initial && initial.id]);

  // Mount Monaco editor when the Java panel renders
  useEffect(() => {
    if (!hasJava || !monacoContainerRef.current) return;
    let cancelled = false;

    if (!window.MonacoAPI) {
      if (monacoContainerRef.current) {
        monacoContainerRef.current.innerHTML = '<div style="color:#dc2626;padding:20px;font-family:monospace">Monaco Editor not available — loading from CDN...</div>';
      }
      return;
    }

    Promise.resolve()
      .then(() => window.MonacoAPI.registerCamelCompletions())
      .then(() => window.MonacoAPI.createEditor(monacoContainerRef.current, {
        value: (pendingSourceRef.current || javaSource || ''),
        language: 'java',
        theme: 'axon-dark',
        readOnly: false,
        height: 520,
      }))
      .then(ed => {
        if (cancelled) { try { ed.dispose(); } catch {} return; }
        monacoEditorRef.current = ed;
        monacoLastValueRef.current = (pendingSourceRef.current || javaSource || '');
        pendingSourceRef.current = null;
        ed.onDidChangeModelContent(() => {
          const v = ed.getValue();
          monacoLastValueRef.current = v;
          setJavaSource(v);
        });
      })
      .catch(err => {
        console.error('[builder] Monaco mount failed:', err);
        if (monacoContainerRef.current && !cancelled) {
          monacoContainerRef.current.innerHTML = '<div style="color:#dc2626;padding:20px;font-family:monospace">Monaco Editor failed to load: ' + err.message + '</div>';
        }
      });

    return () => {
      cancelled = true;
      if (monacoEditorRef.current) {
        try { window.MonacoAPI.dispose(monacoEditorRef.current); } catch {}
        monacoEditorRef.current = null;
      }
    };
  }, [hasJava]);

  // (Removed the sync useEffect that called setValue() on every javaSource change —
  // it caused a feedback loop with onDidChangeModelContent that reset the cursor
  // position on each keystroke. Monaco is now the single source of truth: we push
  // the initial value at creation time (line 3585) and read getValue() on save/validate.)

  // ── Live test run state — split-pane testing framework ───────────────────
  // testPanelOpen: panel visible at all (toggled by Test button in toolbar).
  // testRunId:     current run UUID; null = idle. The SSE subscription is
  //                keyed by this; setting null on completion is safe because
  //                stepStatuses/capturedSteps are retained.
  // runStatus:     IDLE | RUNNING | SUCCESS | FAILED | CANCELED — drives the
  //                run controls (Trigger Now disabled when RUNNING, etc.).
  // stepStatuses:  Map of stepIndex → PENDING|RUNNING|SUCCESS|FAILURE|SKIPPED.
  //                Passed to RouteBuilderCanvas so the linear canvas can
  //                overlay live status badges on each step card. The mapping
  //                relies on DebugInterceptStrategy emitting steps in the
  //                same depth-first order walkRouteSteps() walks them.
  // capturedSteps: Array of step event payloads in arrival order. Source of
  //                truth for the StepInspector tab and the run-log list.
  // selectedStepIdx: Which step the user has clicked on the canvas (null =
  //                show input form; non-null = show inspector).
  const [testPanelOpen, setTestPanelOpen] = useState(false);
  const [testRunId, setTestRunId] = useState(null);
  const [runStatus, setRunStatus] = useState('IDLE');
  const [stepStatuses, setStepStatuses] = useState({});
  const [capturedSteps, setCapturedSteps] = useState([]);
  const [selectedStepIdx, setSelectedStepIdx] = useState(null);
  const [runError, setRunError] = useState('');
  const sseRef = useRef(null);

  // ── Kaoto Designer iframe state ───────────────────────────────────────────
  // The "Advanced" tab loads /kaoto/?embed=1 in an iframe and talks to it via
  // postMessage:
  //   in   kaoto:ready            Kaoto has mounted and can accept content
  //   out  kaoto:load {yaml,name} we hand it the CURRENT draft, not what Axon
  //                               has on disk — the user may have unsaved edits
  //                               in the Visual or YAML tab
  //   in   kaoto:save {yaml,name} user pressed "Apply to route" over there
  //
  // Persisting stays here: the designer applies changes into this editor's
  // draft and the editor's own Save writes them. Two frames writing the same
  // integration is how you get a lost update.
  //
  // This replaced the vendored Karavan designer. Karavan needed two source
  // patches to be embeddable and their diffs no longer exist (KARAVAN.md), so
  // every upgrade meant re-deriving them; Kaoto needs none and is built from
  // kaoto-host/. If /kaoto/ 404s (not built or not deployed) the tab still
  // renders and the iframe shows a 404 — graceful degradation, as before.
  const kaotoRef = useRef(null);
  const [kaotoReady, setKaotoReady] = useState(false);

  const runValidate = useCallback(async () => {
    if (hasJava) {
      // Java DSL mode: compile-check the source
      const source = monacoLastValueRef.current || javaSource || '';
      setValidating(true);
      try {
        const r = await fetch('/api/integrations/validate-java', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: source
        });
        const data = await r.json();
        setValidation({
          valid: data.valid !== false,
          message: data.message || (data.valid === false ? 'Compilation failed' : 'Java compiles successfully'),
          error: data.error || data.details,
          errorType: 'Compile',
          routeIds: data.routeIds ? [data.routeIds] : []
        });
      } catch (err) {
        setValidation({ valid: false, error: 'Could not reach validator: ' + err.message, errorType: 'NetworkError' });
      } finally {
        setValidating(false);
      }
      return;
    }
    // YAML mode: validate YAML
    let yaml;
    try {
      yaml = yamlText;
    } catch (err) {
      setValidation({ valid: false, error: 'YAML generation failed: ' + err.message, errorType: 'GeneratorError' });
      return;
    }
    setValidating(true);
    try {
      const r = await fetch('/api/integrations/validate-yaml', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: yaml || ''
      });
      const data = await r.json();
      setValidation(data);
    } catch (err) {
      setValidation({ valid: false, error: 'Could not reach validator: ' + err.message, errorType: 'NetworkError' });
    } finally {
      setValidating(false);
    }
  }, [activeView, yamlText, routeDef, hasJava, javaSource]);

  // Reset stale validation result when the user makes any change.
  useEffect(()=>{ setValidation(null); }, [yamlText, routeDef]);

  // Reset the handshake when leaving the tab so the next visit re-fires the
  // load (otherwise stale state lingers in the iframe).
  useEffect(() => {
    if (activeView !== 'design') setKaotoReady(false);
  }, [activeView]);

  // ── Kaoto postMessage bridge (parent side) ────────────────────────────────
  useEffect(() => {
    function onMessage(ev) {
      // Same-origin only — the iframe is served from our own static dir, so
      // any cross-origin sender is suspicious.
      if (ev.origin !== window.location.origin) return;
      if (!ev.data || typeof ev.data !== 'object') return;
      const { type } = ev.data;
      if (type === 'kaoto:ready') {
        setKaotoReady(true);
        const win = kaotoRef.current && kaotoRef.current.contentWindow;
        if (!win) return;
        let currentYaml = '';
        try {
          currentYaml = yamlText || '';
        } catch (e) {
          console.warn('[kaoto] generateCamelYaml failed before load:', e);
          currentYaml = yamlText || '';
        }
        win.postMessage({
          type: 'kaoto:load',
          yaml: currentYaml,
          name: ((name && name.trim()) || 'route') + '.camel.yaml',
        }, window.location.origin);
      } else if (type === 'kaoto:save' && typeof ev.data.yaml === 'string') {
        const incoming = ev.data.yaml;
        setYamlText(incoming);
        const parsed = parseYamlToRouteDef(incoming);
        if (parsed) setRouteDef(parsed);
        showToast && showToast('Route updated from the Kaoto Designer', 'success');
      }
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [activeView, yamlText, routeDef, name, showToast]);

  // Both directions are now just a view switch: yamlText is the source of truth
  // either way, so there is nothing to serialise on the way out and nothing to
  // regenerate on the way in.
  const switchToCode = () => {
    setYamlError('');
    setActiveView('code');
  };

  const switchToDesign = () => {
    setYamlError('');
    setActiveView('design');
  };

  // Keep routeDef in step with the YAML for TestRunPanel's step flow. Parse
  // failures are left alone rather than clearing routeDef: the user is midway
  // through typing, and blanking the run panel under them is worse than it
  // briefly describing the last route that parsed.
  useEffect(() => {
    if (hasJava) return;
    if (!yamlText.trim()) return;
    const parsed = parseYamlToRouteDef(yamlText);
    if (parsed) setRouteDef(parsed);
  }, [yamlText, hasJava]);

  // ── Test-run lifecycle (SSE-driven) ──────────────────────────────────────
  // startRun: POST /test-runs to get a runId, open EventSource on the events
  //           endpoint, route step/complete events to the right state setters.
  // cancelRun: DELETE the run; closes the SSE on the server side which then
  //           lets onerror fire on the client.
  // The SSE handler trims/normalises events into state updates. We DELIBERATELY
  // do not store full input/output in stepStatuses — only metadata — so a 100-step
  // run doesn't grow state to MB-sized blobs. Full bodies are lazy-fetched by
  // the StepInspector via GET /test-runs/{runId}/steps/{idx}.
  const startRun = async (payload) => {
    if (!initial || !initial.id) {
      showToast('Save the integration first before testing', 'warning');
      return;
    }
    // Close any previous SSE subscription cleanly before kicking off a fresh run.
    if (sseRef.current) { try { sseRef.current.close(); } catch {} sseRef.current = null; }
    setRunStatus('RUNNING');
    setStepStatuses({});
    setCapturedSteps([]);
    setSelectedStepIdx(null);
    setRunError('');
    try {
      const res = await API('POST', `/api/integrations/${initial.id}/test-runs`, payload || '');
      if (!res || !res.runId) throw new Error('No runId returned');
      setTestRunId(res.runId);
      const url = `/api/integrations/${initial.id}/test-runs/${res.runId}/events`;
      const es = new EventSource(url);
      sseRef.current = es;
      es.addEventListener('step', (ev) => {
        try {
          const data = JSON.parse(ev.data);
          setCapturedSteps(prev => {
            const next = [...prev];
            next[data.stepIndex] = data;
            return next;
          });
          setStepStatuses(prev => ({...prev, [data.stepIndex]: data.status || 'RUNNING'}));
        } catch (e) { console.warn('Bad step event', e); }
      });
      es.addEventListener('complete', (ev) => {
        try {
          const data = JSON.parse(ev.data);
          setRunStatus(data.status || 'SUCCESS');
          if (data.errorMessage) setRunError(data.errorMessage);
        } catch (e) {}
        try { es.close(); } catch {}
        sseRef.current = null;
      });
      es.onerror = () => {
        // Browser fires onerror on normal stream close too; only treat as error
        // if we never saw a complete event.
        if (sseRef.current === es && es.readyState === EventSource.CLOSED) {
          setRunStatus(prev => prev === 'RUNNING' ? 'FAILED' : prev);
        }
      };
    } catch (e) {
      setRunStatus('FAILED');
      setRunError(e.message || String(e));
      showToast('Could not start test: ' + (e.message || e), 'error');
    }
  };

  const cancelRun = async () => {
    if (!testRunId || !(initial||{}).id) return;
    try { await API('DELETE', `/api/integrations/${initial.id}/test-runs/${testRunId}`); } catch {}
    if (sseRef.current) { try { sseRef.current.close(); } catch {} sseRef.current = null; }
    setRunStatus('CANCELED');
  };

  // Auto-cleanup on unmount — never leak an EventSource.
  useEffect(() => () => { if (sseRef.current) { try { sseRef.current.close(); } catch {} } }, []);

  // When the user clicks a step card in the canvas, open it in the inspector.
  // Map RouteBuilderCanvas's path-based callback to the linear stepIndex used
  // by the SSE stream. Since DebugInterceptStrategy emits steps in DFS order
  // matching walkRouteSteps, we can derive the index from the flat list.
  const handleStepClickFromCanvas = (stepPath) => {
    if (!testPanelOpen) return;
    const flat = walkRouteSteps(routeDef.steps || [], 0, ['steps']);
    const idx = flat.findIndex(e =>
      e.path.length === stepPath.length && e.path.every((p, i) => p === stepPath[i]));
    if (idx >= 0) setSelectedStepIdx(idx);
  };

  const save = async () => {
    if (readOnly) { showToast('Stop the integration before editing', 'warning'); return; }
    if (!name.trim()) { showToast('Integration name is required', 'error'); return; }
    if (hasJava && !monacoLastValueRef.current && !javaSource) {
      showToast('Java source cannot be empty', 'error'); return;
    }
    if (!hasJava && !yamlText.trim()) {
      showToast('Design a route in the Design tab, or paste Camel YAML into Code, before saving', 'error');
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: name.trim(),
        description: description.trim(),
        category: category.trim() || 'general',
        status: (initial && initial.status) || 'DRAFT',
        errorStrategy: 'RETRY',
        retryCount: 3,
        projectId: projectId || null,
      };
      // ───────────────────────────────────────────────────────────────────────
      // AXON-1045 — DO NOT reintroduce `triggerType: 'SCHEDULED'` above.
      //
      // This editor designs the *route body*; it has no trigger UI at all (the
      // trigger is owned by IntegrationModal in index.html). It used to send a
      // hardcoded SCHEDULED on every save, which the server honours — so opening
      // any REST/webhook integration here and saving rewrote its trigger to
      // SCHEDULED and unpublished its endpoint. The one that made this urgent is
      // "Fusion CMK Inbound Receiver": Oracle Fusion posts to
      // /api/cmk/fusion/<uuid>, and a builder save moved that endpoint out from
      // under it.
      //
      // Omitted means unchanged — IntegrationService.update() preserves both
      // fields when the body leaves them out, and additionally refuses a
      // triggerType change that arrives without a matching triggerConfig. Echo
      // them back rather than omitting so the record round-trips visibly, and
      // only default to SCHEDULED when creating something that has no trigger yet.
      // See docs/ui-deltas/builder-trigger-preserve.md before merging a static.zip.
      // ───────────────────────────────────────────────────────────────────────
      if (initial) {
        if (initial.triggerType) payload.triggerType = initial.triggerType;
        if (initial.triggerConfig != null) payload.triggerConfig = initial.triggerConfig;
      } else {
        payload.triggerType = 'SCHEDULED';
      }
      if (hasJava) {
        // Java DSL mode: send javaRouteSource, not camelRoute
        const source = monacoLastValueRef.current || javaSource || '';
        payload.builderClassName = (initial && initial.builderClassName) || '';
        payload.javaRouteSource = source;
        if (initial) await API('PUT', '/api/integrations/'+initial.id, payload);
        else await API('POST', '/api/integrations', payload);
      } else {
        // YAML mode: yamlText is the source of truth in both views, so it is
        // written verbatim. flowDefinition is the derived view of it that
        // TestRunPanel reads, never the other way round.
        payload.camelRoute = yamlText;
        payload.flowDefinition = JSON.stringify(parseYamlToRouteDef(yamlText) || routeDef);
        if (initial) await API('PUT', '/api/integrations/'+initial.id, payload);
        else await API('POST', '/api/integrations', payload);
      }
      onSaved();
      showToast(hasJava ? 'Java DSL route saved!' : 'Route integration saved!', 'success');
    } catch(e) { showToast(e.message, 'error'); }
    finally { setSaving(false); }
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(15,17,35,.6)',backdropFilter:'blur(4px)',display:'flex',alignItems:'stretch',justifyContent:'center',zIndex:1000,padding: maximized ? 8 : 20}}>
      <div style={{background:'var(--surface)',borderRadius: maximized ? 10 : 16,width:'100%',maxWidth: maximized ? 'none' : 1400,display:'flex',flexDirection:'column',boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden',transition:'max-width .18s ease, border-radius .18s ease'}}>
        {/* Header */}
        <div style={{padding:'16px 24px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12,flexShrink:0,background:'linear-gradient(135deg,rgba(99,102,241,.08),rgba(139,92,246,.04))'}}>
          <span style={{fontSize:22,color:readOnly?'#dc2626':'#6366f1'}}>{readOnly?<BuilderLockIcon size={22}/>:<BuilderPaletteIcon size={22}/>}</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:800,fontSize:17,color:'var(--text)',display:'flex',alignItems:'center',gap:10}}>
              {readOnly
                ? 'View integration'
                : (initial ? 'Edit integration' : 'New integration')}
              {readOnly&&<span style={{fontSize:10,fontWeight:700,color:'#16a34a',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:20,padding:'2px 8px',letterSpacing:.5}}>● LIVE · READ-ONLY</span>}
            </div>
            <div style={{fontSize:12,color:'var(--text3)',marginTop:2}}>
              {readOnly
                ? 'This route is running. Stop the integration to edit it.'
                : (hasJava ? 'Java DSL route editor — Camel RouteBuilder source' : 'Visual route designer')}
            </div>
          </div>
          {/* Maximize toggle — flips between standard (1400px max) and
              full-viewport (8px gutter). Choice persists per-user. */}
          <button onClick={() => setMaximized(m => !m)}
            title={maximized ? 'Restore window size' : 'Maximize'}
            aria-label={maximized ? 'Restore window' : 'Maximize window'}
            style={{background:'none',border:'1px solid var(--border)',borderRadius:6,color:'var(--text3)',cursor:'pointer',fontSize:13,padding:'4px 8px',lineHeight:1,fontWeight:700,transition:'background .12s, border-color .12s, color .12s'}}
            onMouseEnter={e=>{e.currentTarget.style.background='var(--surface2)';e.currentTarget.style.color='var(--text)';e.currentTarget.style.borderColor='var(--text3)';}}
            onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color='var(--text3)';e.currentTarget.style.borderColor='var(--border)';}}>
            {maximized ? '⊟' : '⊞'}
          </button>
          <button onClick={onClose}
            title="Close" aria-label="Close"
            style={{background:'none',border:'none',color:'var(--text3)',cursor:'pointer',fontSize:20,padding:4,lineHeight:1,display:'inline-flex'}}><CloseIcon size={18}/></button>




        </div>

        {readOnly&&(
          <div style={{padding:'10px 24px',background:'rgba(245,158,11,.08)',borderBottom:'1px solid rgba(245,158,11,.25)',color:'#92400e',fontSize:12.5,display:'flex',alignItems:'center',gap:10}}>
            <span style={{display:'inline-flex'}}><WarningIcon size={16}/></span>
            <div style={{flex:1}}>
              The integration is <b>ACTIVE</b>. Editing is disabled to keep the live route consistent with the saved definition.
              Deactivate the integration first to make changes.
            </div>
          </div>
        )}

        {/* Metadata bar */}
        <div style={{padding:'12px 24px',borderBottom:'1px solid var(--border)',display:'flex',gap:12,alignItems:'center',flexShrink:0,flexWrap:'wrap',background:'var(--surface2)'}}>
          <div style={{flex:'1 1 200px',minWidth:0}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:'var(--text3)',marginBottom:3,textTransform:'uppercase',letterSpacing:'.5px'}}>Name *</label>
            <input value={name} onChange={e=>setName(e.target.value)} placeholder="My Route Integration" readOnly={readOnly}
              style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1.5px solid var(--border2)',background:readOnly?'var(--surface3)':'var(--surface)',color:'var(--text)',fontSize:13,outline:'none',boxSizing:'border-box',cursor:readOnly?'not-allowed':'text'}}/>
          </div>
          <div style={{flex:'2 1 300px',minWidth:0}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:'var(--text3)',marginBottom:3,textTransform:'uppercase',letterSpacing:'.5px'}}>Description</label>
            <input value={description} onChange={e=>setDescription(e.target.value)} placeholder="What does this route do?" readOnly={readOnly}
              style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1.5px solid var(--border2)',background:readOnly?'var(--surface3)':'var(--surface)',color:'var(--text)',fontSize:13,outline:'none',boxSizing:'border-box',cursor:readOnly?'not-allowed':'text'}}/>
          </div>
          <div style={{flex:'0 1 150px',minWidth:0}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:'var(--text3)',marginBottom:3,textTransform:'uppercase',letterSpacing:'.5px'}}>Category</label>
            <input value={category} onChange={e=>setCategory(e.target.value)} placeholder="e.g. Finance" readOnly={readOnly}
              style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1.5px solid var(--border2)',background:readOnly?'var(--surface3)':'var(--surface)',color:'var(--text)',fontSize:13,outline:'none',boxSizing:'border-box',cursor:readOnly?'not-allowed':'text'}}/>
          </div>
          {projects.length>0&&(
            <div style={{flex:'0 1 160px',minWidth:0}}>
              <label style={{display:'block',fontSize:11,fontWeight:700,color:'var(--text3)',marginBottom:3,textTransform:'uppercase',letterSpacing:'.5px'}}>Project</label>
              <select value={projectId} onChange={e=>setProjectId(e.target.value)} disabled={readOnly}
                style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1.5px solid var(--border2)',background:readOnly?'var(--surface3)':'var(--surface)',color:'var(--text)',fontSize:13,outline:'none',boxSizing:'border-box',cursor:readOnly?'not-allowed':'pointer'}}>
                <option value="">— None —</option>
                {projects.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
          )}
          <div style={{flex:'0 0 auto',display:'flex',gap:8,alignItems:'flex-end',paddingTop:18}}>
            <button onClick={onClose} style={{padding:'6px 14px',borderRadius:7,border:'1.5px solid var(--border2)',background:'var(--surface)',color:'var(--text2)',cursor:'pointer',fontSize:13,fontWeight:600}}>{readOnly?'Close':'Cancel'}</button>
            {!readOnly&&(
              <button onClick={save} disabled={saving||!name.trim()}
                style={{padding:'6px 16px',borderRadius:7,border:'none',background:'var(--brand-grad)',color:'#fff',cursor:'pointer',fontSize:13,fontWeight:700,opacity:saving||!name.trim()?0.6:1}}>
                {saving ? <><Spinner/> Saving…</> : <><SaveActionIcon/> Save</>}
              </button>
            )}
          </div>
        </div>

        {/* Route Editor toolbar — three zones:
              LEFT  · view-mode tabs (Visual / YAML / Karavan) styled as
                      proper bottom-border tabs. For Java DSL integrations,
                      a single "Java DSL" tab replaces all three.
              CENTER · route id + (hover) file path
              RIGHT  · quality actions (Test, Validate) */}
        <div style={{display:'flex',alignItems:'stretch',height:42,borderBottom:'1px solid var(--border)',background:'var(--surface)',flexShrink:0,paddingLeft:24,paddingRight:24}}>

          {/* LEFT — view-mode tabs */}
          <div style={{display:'flex'}}>
            {hasJava ? (
              <button key="java" onClick={()=>{setActiveView('java');}} title="Java DSL RouteBuilder source"
                style={{padding:'0 16px',border:'none',background:'none',cursor:'pointer',
                  fontSize:13,fontWeight:700,
                  color: 'var(--text)',
                  borderBottom:'2px solid var(--brand-start)',
                  marginBottom:-1,
                  display:'inline-flex',alignItems:'center',gap:6}}>
                <span style={{fontSize:14,lineHeight:1,display:'inline-flex'}}><BuilderCodeIcon size={14}/></span>Java DSL
              </button>
            ) : (
              [
                {id:'design', icon:<BuilderPaletteIcon size={14}/>, label:'Design', title:'Design this route visually (Kaoto)', onClick:switchToDesign},
                {id:'code',   icon:<BuilderFileIcon size={14}/>, label:'Code', title:'Edit the Camel YAML directly', onClick:switchToCode},
              ].map(t => {
                const active = activeView === t.id;
                return (
                  <button key={t.id} onClick={t.onClick} title={t.title||t.label}
                    style={{padding:'0 16px',border:'none',background:'none',cursor:'pointer',
                      fontSize:13,fontWeight: active ? 700 : 600,
                      color: active ? 'var(--text)' : 'var(--text3)',
                      borderBottom:'2px solid '+(active ? 'var(--brand-start)' : 'transparent'),
                      marginBottom:-1,
                      display:'inline-flex',alignItems:'center',gap:6,
                      transition:'color .12s, border-color .12s'}}
                    onMouseEnter={e=>{ if(!active) e.currentTarget.style.color='var(--text2)'; }}
                    onMouseLeave={e=>{ if(!active) e.currentTarget.style.color='var(--text3)'; }}>
                    <span style={{fontSize:14,lineHeight:1,display:'inline-flex'}}>{t.icon}</span>{t.label}
                  </button>
                );
              })
            )}
          </div>

          {/* CENTER — route id. Subtle label, monospace value, optional
              file-path icon on the right that reveals the on-disk YAML
              path on hover (long UUIDs no longer hog horizontal space). */}
          <div style={{display:'flex',alignItems:'center',gap:8,paddingLeft:28,minWidth:0,flex:1}}>
            <span style={{fontSize:10,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.5px',fontWeight:700,flexShrink:0}}>Route ID</span>
            <input value={routeDef.id||''} onChange={e=>setRouteDef(r=>({...r,id:e.target.value}))} readOnly={readOnly}
              title={(initial||{}).routeFilePath ? 'On-disk file: '+(initial||{}).routeFilePath : 'The route ID for this integration'}
              style={{padding:'4px 8px',borderRadius:5,
                border:'1px solid '+(readOnly?'transparent':'var(--border)'),
                background:readOnly?'transparent':'var(--surface2)',
                color:'var(--text2)',fontSize:12,
                fontFamily:'ui-monospace,Consolas,monospace',
                outline:'none',width:260,minWidth:0,
                cursor:readOnly?'default':'text'}}/>
            {(initial||{}).routeFilePath && (
              <span title={'Route file: '+initial.routeFilePath}
                style={{fontSize:13,color:'var(--text3)',cursor:'help',userSelect:'none',flexShrink:0,opacity:.7,display:'inline-flex'}}><BuilderFileIcon size={13}/></span>
            )}
          </div>

          {/* RIGHT — quality actions. Test launches the split-pane live
              runner; Validate runs the route through the Camel YAML schema
              and shows pass/fail in-place (the button itself colours). */}
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {/* Test — opens the split-pane live test framework on the right.
                Only available on a saved integration (we need an id to fire). */}
            <button onClick={()=>setTestPanelOpen(v=>!v)}
              disabled={!initial || !initial.id}
              title={(initial||{}).id
                ? (testPanelOpen ? 'Close test panel' : 'Open live test panel')
                : 'Save the integration first to enable testing'}
              style={{padding:'5px 12px',borderRadius:7,border:'1px solid '+(testPanelOpen?'rgba(99,102,241,.5)':'var(--border)'),
                cursor: (initial||{}).id ? 'pointer' : 'not-allowed',fontSize:12.5,fontWeight:600,
                background: testPanelOpen ? 'rgba(99,102,241,.15)' : 'var(--surface)',
                color: testPanelOpen ? '#4338ca' : ((initial||{}).id ? 'var(--text2)' : 'var(--text3)'),
                opacity: (initial||{}).id ? 1 : 0.6,
                display:'inline-flex',alignItems:'center',gap:5}}>
              <BuilderTestIcon/> Test
              {runStatus === 'RUNNING' && <span style={{display:'inline-block',width:6,height:6,borderRadius:'50%',background:'#6366f1',animation:'tlPulse 1.2s infinite'}}/>}
            </button>
            {/* Validate */}
            <button onClick={runValidate} disabled={validating}
              title={hasJava ? "Compile-check the Java DSL source" : "Validate YAML against the route schema"}
              style={{padding:'5px 12px',borderRadius:7,
                border:'1px solid '+(validation==null ? 'var(--border)' : validation.valid ? 'rgba(22,163,74,.4)' : 'rgba(239,68,68,.4)'),
                cursor:validating?'wait':'pointer',fontSize:12.5,fontWeight:600,
                background: validation==null ? 'var(--surface)' : validation.valid ? 'rgba(22,163,74,.12)' : 'rgba(239,68,68,.1)',
                color: validation==null ? 'var(--text2)' : validation.valid ? '#16a34a' : '#dc2626'}}>
              {validating ? <><Spinner/> Validating…</>
                : validation==null ? <><BuilderValidateIcon/> Validate</>
                : validation.valid ? <><CheckCircleIcon size={13}/> Valid</>
                : <><WarningIcon size={13}/> Invalid</>}
            </button>
          </div>
        </div>

        {yamlError && <div style={{padding:'6px 24px',background:'#fef2f2',borderBottom:'1px solid #fecaca',color:'#dc2626',fontSize:12,fontWeight:600}}>{yamlError}</div>}

        {/* Validation result banner */}
        {validation && (
          <div style={{padding:'8px 24px',display:'flex',alignItems:'flex-start',gap:10,
              background: validation.valid ? 'rgba(22,163,74,.08)' : 'rgba(239,68,68,.06)',
              borderBottom: '1px solid '+(validation.valid?'rgba(22,163,74,.25)':'rgba(239,68,68,.25)'),
              color: validation.valid ? '#15803d' : '#b91c1c',
              fontSize:12.5}}>
            <span style={{display:'inline-flex'}}>{validation.valid ? <CheckCircleIcon size={14}/> : <WarningIcon size={14}/>}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700}}>
                {validation.valid
                  ? (validation.message || (hasJava ? 'Java DSL source compiles cleanly' : 'YAML is valid against the route schema'))
                  : (hasJava ? 'Java DSL source has compilation errors' : 'YAML is invalid')}
              </div>
              {!validation.valid && validation.error && (
                <div style={{fontFamily:'ui-monospace,monospace',marginTop:3,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>{validation.error}</div>
              )}
              {validation.valid && validation.routeIds && validation.routeIds.length>0 && (
                <div style={{fontSize:11,color:'var(--text3)',marginTop:2}}>parsed route id(s): {validation.routeIds.join(', ')}</div>
              )}
            </div>
            <button onClick={()=>setValidation(null)} title="Dismiss"
              style={{background:'none',border:'none',cursor:'pointer',color:'inherit',opacity:.6,fontSize:14,lineHeight:1,padding:2}}>✕</button>
          </div>
        )}

        {/* Canvas / YAML editor / Karavan iframe / Java DSL editor */}
        <div style={{flex:1,overflow:'hidden',minHeight:0,position:'relative',display:'flex',flexDirection:'row'}}>
          <div style={{flex:'1 1 0',minWidth:0,minHeight:0,overflow:'hidden',display: testPanelOpen ? 'none' : 'flex',flexDirection:'column'}}>
          {hasJava && activeView === 'java' ? (
            <div style={{height:'100%',display:'flex',flexDirection:'column',padding:12,gap:8,background:'#1a1a2e'}}>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                <span style={{fontSize:11,color:'#dcdcaa',fontWeight:600,fontFamily:'monospace'}}>
                  {initial && initial.builderClassName ? initial.builderClassName + '.java' : 'Java DSL — RouteBuilder source'}
                </span>
                <div style={{flex:1}}/>
                <button onClick={()=>{ if(monacoEditorRef.current) navigator.clipboard.writeText(monacoEditorRef.current.getValue()).then(()=>showToast('Copied','success')); }}
                  style={{padding:'3px 10px',borderRadius:5,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.1)',color:'#dcdcaa',cursor:'pointer',fontSize:11,display:'inline-flex',alignItems:'center',gap:6}}><BuilderCopyIcon/> Copy</button>
              </div>
              <div ref={monacoContainerRef} style={{flex:1,borderRadius:8,overflow:'hidden',border:'1px solid rgba(255,255,255,.15)',minHeight:0}}/>
            </div>
          ) : activeView === 'code' ? (
            <div style={{height:'100%',display:'flex',flexDirection:'column',padding:16,gap:8,background:'#1e1e2e'}}>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                <span style={{fontSize:11,color:'#a5f3fc',fontWeight:600,fontFamily:'monospace'}}>Camel YAML — edit directly, or switch to Design to draw it</span>
                <div style={{flex:1}}/>
                <button onClick={()=>navigator.clipboard.writeText(yamlText).then(()=>showToast('Copied','success'))}
                  style={{padding:'3px 10px',borderRadius:5,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.1)',color:'#a5f3fc',cursor:'pointer',fontSize:11,display:'inline-flex',alignItems:'center',gap:6}}><BuilderCopyIcon/> Copy</button>
              </div>
              <textarea
                value={yamlText}
                onChange={e=>setYamlText(e.target.value)}
                spellCheck={false}
                readOnly={readOnly}
                style={{flex:1,background:'transparent',border:'1px solid rgba(255,255,255,.15)',borderRadius:8,color:'#a5f3fc',
                  fontFamily:'ui-monospace,Consolas,monospace',fontSize:12.5,lineHeight:1.6,padding:14,resize:'none',outline:'none',
                  tabSize:2,cursor:readOnly?'not-allowed':'text'}}
                placeholder={'- route:\n    id: my-route\n    from:\n      uri: "timer://hello"\n      parameters:\n        period: "5000"\n      steps:\n        - log:\n            message: "Hello World"\n            loggingLevel: INFO'}
              />
            </div>
          ) : (
            <div style={{height:'100%',width:'100%',position:'relative',background:'#1e1e2e'}}>
              <iframe
                ref={kaotoRef}
                /* index.html explicitly, not the bare directory: the /kaoto/ view
                   controller ships with the JAR, and the built tree is deployed
                   separately by `deploy.sh ui`. Naming the file keeps the tab
                   working on a host whose backend predates that forward. */
                src={`/kaoto/index.html?embed=1&t=${(initial && initial.id) || 'new'}`}
                title="Advanced Route Designer"
                style={{width:'100%',height:'100%',border:'none',display:'block',background:'#1e1e2e'}}
              />
              {!kaotoReady && (
                <div style={{position:'absolute',top:12,left:16,padding:'4px 10px',background:'rgba(0,0,0,.55)',
                    color:'#a5f3fc',fontSize:11,fontFamily:'monospace',borderRadius:6,pointerEvents:'none'}}>
                  Loading the advanced designer…
                </div>
              )}
            </div>
          )}
          </div>
          {/* Test panel — slides in on the right when toolbar's Test button is clicked.
              Canvas stays visible (and clickable) so users can drill into any step's
              I/O while the run is mid-flight or already complete. */}
          {testPanelOpen && (
            <TestRunPanel
              routeDef={routeDef}
              integration={initial}
              runStatus={runStatus}
              runError={runError}
              capturedSteps={capturedSteps}
              selectedStepIdx={selectedStepIdx}
              stepStatuses={stepStatuses}
              testRunId={testRunId}
              onTriggerRun={startRun}
              onCancelRun={cancelRun}
              onSelectStep={setSelectedStepIdx}
              onClose={()=>setTestPanelOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function RoutesPage({showToast,projects=[],navTarget,clearNavTarget}){
  const [files,setFiles]=useState([]);
  const [loadingFiles,setLoadingFiles]=useState(true);
  const [selected,setSelected]=useState(null);
  const [selectedSlug,setSelectedSlug]=useState(null);
  const [loadingFile,setLoadingFile]=useState(false);
  const [editContent,setEditContent]=useState('');
  const [saving,setSaving]=useState(false);
  const [view,setView]=useState('yaml');
  const [newModal,setNewModal]=useState(false);
  const [testModal,setTestModal]=useState(null); // {integration} when open
  const [testExec,setTestExec]=useState(null);
  const [testing,setTesting]=useState(false);

  const loadFiles=useCallback(async()=>{
    try{const d=await API('GET','/api/routes/files');setFiles(d);}
    catch(e){showToast('Failed to load route files','error');}
    finally{setLoadingFiles(false);}
  },[]);

  useEffect(()=>{loadFiles();},[]);

  // When the user navigates here from the Projects page (deep link), auto-select
  // the requested route file once the file list has loaded, then clear the target.
  useEffect(()=>{
    if(!navTarget||loadingFiles||files.length===0)return;
    const match=files.find(f=>f.name===navTarget.filename
       && (navTarget.slug?f.projectSlug===navTarget.slug:!f.projectSlug));
    if(match){
      selectFile(match.name,match.projectSlug||null);
      clearNavTarget&&clearNavTarget();
    }
  },[navTarget,loadingFiles,files,selectFile,clearNavTarget]);

  const selectFile=useCallback(async(name,slug)=>{
    try{
      setLoadingFile(true);
      const qs=slug?`?project=${encodeURIComponent(slug)}`:'';
      const d=await API('GET',`/api/routes/files/${name}${qs}`);
      setSelected(d);setSelectedSlug(slug||null);setEditContent(d.content||'');
    }catch(e){showToast('Failed to load '+name,'error');}
    finally{setLoadingFile(false);}
  },[]);

  const save=async()=>{
    if(!selected||!(selected||{}).editable)return;
    try{
      setSaving(true);
      const qs=selectedSlug?`?project=${encodeURIComponent(selectedSlug)}`:'';
      const r=await API('PUT',`/api/routes/files/${selected.name}${qs}`,{content:editContent});
      showToast(r.message||'Saved and reloaded','success');
      await loadFiles();await selectFile(selected.name,selectedSlug);
    }catch(e){showToast('Save failed: '+e.message,'error');}
    finally{setSaving(false);}
  };

  const exportToFs=async()=>{
    if(!selected)return;
    try{
      const r=await API('POST',`/api/routes/files/${selected.name}/export`);
      showToast(r.message,'success');
      await loadFiles();await selectFile(selected.name,selectedSlug);
    }catch(e){showToast('Export failed: '+e.message,'error');}
  };

  const deleteFile=async()=>{
    if(!selected||!(selected||{}).editable)return;
    if(!confirm(`Delete ${selected.name}? This will stop and remove the route.`))return;
    try{
      const qs=selectedSlug?`?project=${encodeURIComponent(selectedSlug)}`:'';
      await API('DELETE',`/api/routes/files/${selected.name}${qs}`);
      showToast(selected.name+' deleted','success');
      setSelected(null);setSelectedSlug(null);setEditContent('');await loadFiles();
    }catch(e){showToast('Delete failed: '+e.message,'error');}
  };

  const toggleRoute=async(routeId,status)=>{
    try{
      const action=status==='Started'?'stop':'start';
      await API('POST',`/api/routes/files/routes/${routeId}/${action}`);
      showToast(`Route ${routeId} ${action}ed`,'success');
      await selectFile(selected.name,selectedSlug);
    }catch(e){showToast('Failed: '+e.message,'error');}
  };

  // Open the test modal for the currently-selected route file. The filename is
  // {integrationId}.camel.yaml — we look up the integration so the modal knows
  // its name, mode, and id.
  const openTest=async()=>{
    if(!selected)return;
    const id=selected.name.replace(/\.camel\.yaml$|\.yaml$/,'');
    try{
      const wrapped=await API('GET',`/api/integrations/${id}`);
      const integration=(wrapped&&wrapped.integration)||wrapped;
      setTestModal({integration});
    }catch(e){
      showToast('Test requires an integration linked to this route file. '+
                'Static classpath routes (.jar) cannot be tested directly — export to filesystem first.','warning');
    }
  };

  const runTest=async(body)=>{
    if(!testModal)return;
    setTesting(true);
    try{
      const result=await API('POST',`/api/integrations/${testModal.integration.id}/test`,body||'');
      setTestModal(null);
      setTestExec(result);
    }catch(e){showToast('Test failed: '+e.message,'error');}
    finally{setTesting(false);}
  };

  // Group files by projectSlug for the sidebar
  const grouped = React.useMemo(()=>{
    const unassigned=[];
    const bySlug={};
    files.forEach(f=>{
      if(f.projectSlug){
        if(!bySlug[f.projectSlug])bySlug[f.projectSlug]=[];
        bySlug[f.projectSlug].push(f);
      } else {
        unassigned.push(f);
      }
    });
    const sections=[];
    Object.keys(bySlug).sort().forEach(slug=>{
      const proj=projects.find(p=>p.slug===slug);
      sections.push({slug,name:(proj||{}).name||slug,color:(proj||{}).color||'#6366f1',files:bySlug[slug]});
    });
    if(unassigned.length>0) sections.push({slug:null,name:'Unassigned',color:'#9099c0',files:unassigned});
    return sections;
  },[files,projects]);

  return(
    <div style={{display:'flex',flexDirection:'column',height:'calc(100vh - 140px)'}}>
      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:18,flexShrink:0}}>
        <div>
          <div className="page-title">Route Editor</div>
          <div className="page-subtitle">View, edit and hot-reload Axon route YAML files</div>
        </div>
        <button className="btn btn-primary" onClick={()=>setNewModal(true)}><BuilderAddIcon/> New Route File</button>
      </div>

      <div style={{flex:1,display:'flex',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden',boxShadow:'var(--shadow)',minHeight:0}}>

        {/* ── Left: File list ── */}
        <div style={{width:256,borderRight:'1px solid var(--border)',display:'flex',flexDirection:'column',flexShrink:0,background:'var(--surface2)'}}>
          <div style={{padding:'11px 16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
            <span style={{fontWeight:700,fontSize:11.5,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.8px'}}>Route Files</span>
            <span style={{fontSize:11,color:'var(--text3)',background:'var(--surface3)',padding:'1px 7px',borderRadius:10,fontWeight:600,border:'1px solid var(--border)'}}>{files.length}</span>
          </div>
          <div style={{flex:1,overflow:'auto'}}>
            {loadingFiles?(
              <div style={{padding:24,textAlign:'center',color:'var(--text3)',fontSize:13}}><Spinner/></div>
            ):files.length===0?(
              <div style={{padding:'40px 16px',textAlign:'center',color:'var(--text3)',fontSize:12,lineHeight:1.6}}>No route files found.<br/>Create one to get started.</div>
            ):grouped.map(section=>(
              <div key={section.slug||'_unassigned'}>
                {/* Project/section header */}
                <div style={{padding:'8px 14px 4px',display:'flex',alignItems:'center',gap:6,borderBottom:'1px solid var(--border)',background:'var(--surface)',position:'sticky',top:0,zIndex:1}}>
                  <span style={{width:8,height:8,borderRadius:'50%',background:section.color,flexShrink:0}}/>
                  <span style={{fontWeight:700,fontSize:10.5,color:'var(--text2)',textTransform:'uppercase',letterSpacing:'.7px',flex:1}}>{section.name}</span>
                  <span style={{fontSize:10,color:'var(--text3)',background:'var(--surface3)',padding:'1px 5px',borderRadius:8,border:'1px solid var(--border)',fontWeight:600}}>{section.files.length}</span>
                </div>
                {section.files.map(f=>{
                  const isSel=(selected||{}).name===f.name&&selectedSlug===section.slug;
                  return(
                    <div key={f.name} className={`route-file-item${isSel?' active':''}`} onClick={()=>!loadingFile&&selectFile(f.name,section.slug)}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:5}}>
                        <span style={{fontWeight:600,fontSize:12.5,color:'var(--text)',wordBreak:'break-all',lineHeight:1.3,flex:1,marginRight:6}}>
                          {f.name.replace('.camel.yaml','').replace('.yaml','')}
                        </span>
                        {f.running&&<span style={{width:7,height:7,borderRadius:'50%',background:'#22c55e',boxShadow:'0 0 0 2px rgba(34,197,94,.25)',flexShrink:0}} title="Running"/>}
                      </div>
                      <div style={{display:'flex',gap:4,flexWrap:'wrap',alignItems:'center'}}>
                        {f.editable
                          ?<span style={{fontSize:10,padding:'1px 6px',borderRadius:4,background:'rgba(37,99,235,0.1)',color:'#2563eb',fontWeight:600,border:'1px solid rgba(37,99,235,0.2)',display:'inline-flex',alignItems:'center',gap:3}}><PencilIcon size={9}/> fs</span>
                          :<span style={{fontSize:10,padding:'1px 6px',borderRadius:4,background:'var(--surface3)',color:'var(--text3)',fontWeight:600,border:'1px solid var(--border)',display:'inline-flex',alignItems:'center',gap:3}}><LockIcon size={9}/> jar</span>}
                        {f.routeCount>0&&<span style={{fontSize:10,color:'var(--text3)',fontWeight:500}}>{f.routeCount} route{f.routeCount!==1?'s':''}</span>}
                        {f.lastModified&&<span style={{fontSize:10,color:'var(--text3)'}}>{new Date(f.lastModified).toLocaleDateString()}</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div style={{padding:'8px 12px',borderTop:'1px solid var(--border)',flexShrink:0}}>
            <button className="btn btn-ghost btn-sm w-full" onClick={loadFiles}><BuilderRefreshIcon size={14}/> Refresh</button>
          </div>
        </div>

        {/* ── Right: Editor area ── */}
        <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden',minWidth:0}}>
          {loadingFile?(
            <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--text3)',gap:8}}>
              <Spinner/><span>Loading…</span>
            </div>
          ):!selected?(
            <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',color:'var(--text3)',gap:10}}>
              <div style={{fontSize:52,opacity:.35,display:'inline-flex'}}><BuilderRouteIcon size={48}/></div>
              <div style={{fontWeight:700,fontSize:15,color:'var(--text2)'}}>Select a Route File</div>
              <div style={{fontSize:13}}>Pick a file on the left to view and edit its YAML</div>
            </div>
          ):(
            <>
              {/* Toolbar */}
              <div style={{padding:'8px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:8,flexShrink:0,background:'var(--surface)',flexWrap:'wrap'}}>
                <div style={{flex:1,minWidth:0,display:'flex',alignItems:'center',gap:8}}>
                  <span style={{fontSize:14,display:'inline-flex'}}><BuilderFileIcon size={14}/></span>
                  <span style={{fontWeight:700,fontSize:13,color:'var(--text)',fontFamily:'ui-monospace,monospace',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}}>{selected.name}</span>
                  {selected.editable
                    ?<span style={{fontSize:10,padding:'2px 6px',borderRadius:4,background:'rgba(37,99,235,0.1)',color:'#2563eb',fontWeight:600,border:'1px solid rgba(37,99,235,0.2)',flexShrink:0}}>editable</span>
                    :<span style={{fontSize:10,padding:'2px 6px',borderRadius:4,background:'var(--surface3)',color:'var(--text3)',fontWeight:600,border:'1px solid var(--border)',flexShrink:0}}>classpath</span>}
                </div>
                {/* View toggle */}
                <div style={{display:'flex',background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:7,padding:3,gap:2,flexShrink:0}}>
                  {[
                    ['yaml',<><BuilderFileIcon size={12}/> YAML</>],
                    ['split','Split'],
                    ['visual',<><BuilderPaletteIcon size={12}/> Visual</>],
                  ].map(([v,l])=>(
                    <button key={v} className={`view-toggle-btn${view===v?' active':''}`} onClick={()=>setView(v)}>{l}</button>
                  ))}
                </div>
                {/* Action buttons */}
                {!selected.editable?(
                  <button className="btn btn-secondary btn-sm" onClick={exportToFs}><BuilderExportIcon/> Export to Edit</button>
                ):(
                  <>
                    <button className="btn btn-secondary btn-sm" onClick={openTest} disabled={testing} title="Run a debug test with per-activity I/O capture">{testing?<><Spinner/> Testing…</>:<><BuilderTestIcon/> Test</>}</button>
                    <button className="btn btn-primary btn-sm" onClick={save} disabled={saving}>{saving?<><Spinner/> Saving…</>:<><SaveActionIcon/> Save & Reload</>}</button>
                    <button className="btn btn-danger btn-sm btn-icon" onClick={deleteFile} title="Delete file"><BuilderDeleteIcon/></button>
                  </>
                )}
              </div>

              {/* Route status pills */}
              {(selected.routeIds||[]).length>0&&(
                <div style={{padding:'6px 14px',borderBottom:'1px solid var(--border)',display:'flex',gap:6,flexWrap:'wrap',alignItems:'center',background:'var(--surface2)',flexShrink:0}}>
                  <span style={{fontSize:10.5,fontWeight:700,color:'var(--text3)',letterSpacing:'.6px',textTransform:'uppercase',marginRight:2}}>Routes</span>
                  {selected.routeIds.map(id=>{
                    const status=(selected.routeStatuses||{})[id]||'UNKNOWN';
                    const started=status==='Started';
                    const col=started?'var(--success)':status==='UNKNOWN'||status==='NOT_DEPLOYED'?'var(--text3)':'var(--error)';
                    const pillBg=started?'var(--success-bg)':'var(--surface3)';
                    const pillBdr=started?'var(--success-border)':'var(--border)';
                    return(
                      <div key={id} className="route-status-pill" style={{background:pillBg,border:`1px solid ${pillBdr}`}}>
                        <span style={{width:5,height:5,borderRadius:'50%',background:col,flexShrink:0,display:'inline-block'}}/>
                        <span style={{fontWeight:600,color:'var(--text)',fontFamily:'ui-monospace,monospace',fontSize:11}}>{id}</span>
                        <span style={{color:'var(--text3)',fontSize:10,marginLeft:2}}>{status}</span>
                        {selected.editable&&(
                          <button onClick={()=>toggleRoute(id,status)}
                            style={{background:'none',border:'none',cursor:'pointer',padding:'0 1px',fontSize:12,color:started?'var(--error)':'var(--success)',fontWeight:700,lineHeight:1,marginLeft:3}}
                            title={started?'Stop':'Start'}>
                            {started?'⏹':'▶'}
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Content: Monaco + Visual */}
              <div style={{flex:1,display:'flex',overflow:'hidden',minHeight:0}}>
                {(view==='yaml'||view==='split')&&(
                  <div style={{flex:view==='split'?'0 0 50%':1,borderRight:view==='split'?'1px solid var(--border)':'none',overflow:'hidden',display:'flex',flexDirection:'column',minWidth:0}}>
                    <YamlEditor
                      value={editContent}
                      onChange={(selected||{}).editable?setEditContent:undefined}
                      readOnly={!(selected||{}).editable}
                    />
                  </div>
                )}
                {(view==='visual'||view==='split')&&(
                  <div style={{flex:1,overflow:'auto',padding:16,background:'var(--surface2)',minWidth:0}}>
                    <RouteCanvas
                      yaml={editContent}
                      routeIds={(selected||{}).routeIds}
                      routeStatuses={(selected||{}).routeStatuses}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {newModal&&<NewRouteModal onClose={()=>setNewModal(false)} onCreated={name=>{setNewModal(false);loadFiles().then(()=>selectFile(name));}} showToast={showToast}/>}

      {testModal&&<TestRunModal
        integration={testModal.integration}
        onClose={()=>setTestModal(null)}
        onRun={runTest}
      />}

      {testExec&&<ActivityDrawer exec={testExec} onClose={()=>setTestExec(null)}/>}
    </div>
  );
}
